export default {
    VIETNAMESE: "Tiếng việt",
    ENGLISH: "English",
    JAPANESE: "日本語",
    KOREAN: "한국어",
    CHINESE: "中文",
    LAO: "ພາສາລາວ",
    KHMER: "ភាសាខ្មែរ", //tiếng campuchia
    SYNC: "동기화",
    PLEASE_SELECT_DATE_LESS_6_MONTH: "날짜 범위를 6개월 이하로 선택하십시오",
    //#region chainManager
    CHAIN_DASHBOARD_INFO: "체인",
    CHAIN_DASHBOARD: "체인 대시보드",
    BOOKING_DASHBOARD: "예약 대시보드",
    USE_HOTEL: "호텔 사용",
    //#endregion
    //#region alert
    CANCEL_SUCCESS: "업데이트 성공",
    BOOKING_PAID: "결제 완료",
    BOOKING_CANCELED: "예약을 취소할 수 없습니다. 상태를 확인하십시오",
    LOCATION_IS_NOT_EXIST: "위치가 존재하지 않습니다",
    ROOM_AVAILS_INCORRECT: "빈 방 수는 신고된 총 객실 수보다 클 수 없습니다",
    PROMOTION_NULL: "프로모션이 존재하지 않습니다",
    CANCLE_FAILE: "취소 실패",
    DELETE_FAILE: "삭제 실패",
    GROUP_USED: "사용자 그룹이 사용 중입니다",
    TRANSDATE_INCORRECT: "결제 날짜는 예약일과 체크아웃 날짜 사이에 있어야 합니다",
    AMOUNT_INCORRECT: "잘못된 결제 금액",
    HAS_NO_DATA: "데이터가 없습니다",
    LOCATION_NOT_EXIST: "위치가 존재하지 않습니다",
    UPDATE_SUCCESS: "성공적으로 업데이트되었습니다",
    UPDATE_CUCCESS: "성공적으로 업데이트되었습니다",
    DELETE_SUCCESS: "성공적으로 삭제되었습니다",
    CREATE_SUCCESS: "성공적으로 생성되었습니다",
    REGISTER_SUCCESS: "성공적으로 등록되었습니다",
    UPLOAD_SUCCESS: "성공적으로 업데이트되었습니다",
    PROMOTIONS_ARE_BEING_USED: "프로모션이 사용 중입니다",
    PROMOTIONS_DO_NOT_BELONG_TO_HOTELS: "프로모션이 호텔에 속하지 않습니다",
    COUNPON_EXIST: "쿠폰이 존재합니다",
    USER_IS_EXIST: "사용자 이름이 이미 존재합니다",
    EMAIL_USER_IS_EXIST: "이메일이 이미 존재합니다",
    EMAIL_HOTEL_IS_EXIST: "이메일이 이미 존재합니다",
    ACCOUNT_IS_TAKEN: "사용자 이름이 이미 사용 중입니다",
    USER_NAME_OR_EMAIL_IS_EXISTED: "사용자 이름 또는 이메일이 이미 존재합니다",
    CANNOT_FIND_SOURCE: "소스를 찾을 수 없습니다",
    IMAGE_CAPACITY_NOT_BIGGER_THAN: "최대 이미지 업로드 크기:",
    FILE_CAPACITY_NOT_BIGGER_THAN: "최대 파일 업로드 크기:",
    IMAGE_SIZE_NOT_BIGGER_THAN: "사진의 최소 크기",
    INVALID_IMAGE_FORMAT: "잘못된 이미지 형식",
    INVALID_FILE_FORMAT: "잘못된 파일 형식",
    DELETE_FAIL: "삭제 실패",
    IMAGE_MAIN_EMPTY: "메인 이미지가 비어 있습니다",
    ROOM_EMPTY: "방이 비어 있습니다",
    ROOM_IS_SELECTING: "방을 선택 중입니다",
    NOT_SELECTED_PROMOTION: "선택된 프로모션이 없습니다",
    MISSING_FIELD: "필수 정보를 모두 입력하십시오",
    CONFIRM_DELETE_PHOTOS: "사진 삭제 확인",
    MAIN_IMAGES_MUST_EXIST: "메인 사진이 있어야 합니다",
    CONFIRM_DELETE_POLICY: "정책 삭제 확인",
    CONFIRM_DELETE_SALE_PACKAGE: "이 판매 방 패키지를 삭제하시겠습니까",
    CONFIRM_DELETE_PROMOTION_PACKAGE: "이 프로모션 패키지를 삭제하시겠습니까",
    CONFIRM_DELETE_ROOM: "방 삭제 확인",
    UPLOAD_EXPIRED: "업로드 만료됨",
    PAYMENT_METHOD_HAS_NOT_SELECTED: "결제 방법이 선택되지 않았습니다",
    SETTING_GATEWAY_EMPTY: "게이트웨이 설정이 존재하지 않습니다",
    DEPOSIT_COMPARE_PAYMENT: "결제 기한은 보증금 지급 조건보다 클 수 없습니다",
    TIP_MAIN_IMAGE: "호텔 아바타는 첫 번째 사진입니다. 사진을 드래그하여 표시 순서를 변경하십시오",
    TIP_MAIN_ROOM_IMAGE: "객실 아바타는 첫 번째 사진입니다. 사진을 드래그하여 표시 순서를 변경하십시오",
    CUSTOMER_PACKAGE_NOT_BIGGER_THAN_ROOM: "패키지의 적용 인원 수는 객실의 최대 인원 수보다 클 수 없습니다",
    FIELD_NUMBER_FORMAT: "숫자만 입력 가능합니다, 공백은 허용되지 않습니다",
    FIELD_POSITIVE_FORMAT: "양의 정수만 입력 가능하며 공백은 허용되지 않습니다",
    FIELD_DISTANCE_FORMAT: "숫자, 점(.)만 입력 가능하며 공백은 허용되지 않습니다",
    CHAIN_NAME_EMPTY: "체인 이름이 비어 있습니다",
    USER_IS_NOT_EXIT: "사용자가 존재하지 않습니다",
    USER_IS_NOT_EXIST: "사용자가 존재하지 않습니다",
    HOTEL_WAS_IN_CHAIN: "호텔이 체인에 속해 있습니다",
    //#endregion

    DESCRIPTION_INFO: "설명",
    REQUIRED: "*",
    SELECT_ALL: "모두 선택",
    IMAGES: "사진",
    HOTEL_PHOTO: "호텔 사진",
    LIBRARY: "갤러리",
    ADD_NEW: "생성",
    AND: "및",
    BACK: "뒤로",
    SAVE: "저장",
    EDIT: "편집",
    DELETE: "삭제",
    COPY: "복사",
    POLICY: "정책",
    ALWAYS: "항상",
    IN_PERIOD: "기간",
    GENERAL_SETTING: "일반 설정",
    PAYMENT_POLICY: "결제 정책",
    CANCELATION_POLICY: "취소 정책",
    PAY_GATE: "결제 게이트",
    AGENT_STOP_CONNECT: "에이전트 연결 중지",
    WARNING_METHOD: "경고 방법",
    ALERT_RECEIVING_METHOD: "경고 방법",
    SELECT_WARNING_METHOD: "경고 방법 선택",
    WARNING_QTY_ROOM: "설정된 임계값에 도달할 때 방 수 알림",
    SETTING_WARNING_ROOM: "설정된 방 수에 도달할 때 알림 전송",
    SEND_WARNING_ANY_ROOM: "설정된 방 수보다 적은 방 수에 도달하면 알림 전송",
    SEND_WARNING_ROOM: "설정된 방 수에 도달할 때 알림 전송",
    QTY_ROOM_LESS_THAN: "방 수 부족",
    HOTEL_WARNING: "경고 방법",
    SETTING_AT_LEAST_1_ROOM: "경고 임계값을 설정하려면 최소 1개 이상의 방 유형을 선택하십시오.",

    // HOTEL INFORMATION
    REGISTER_INFO: "등록 정보",
    EXTENSION: "편의시설",
    NEARBY_PLACE: "인근 장소",
    HOTEL_CHAIN: "호텔 체인",
    HOTEL_REGISTER_INFO: "호텔 등록 정보",

    //#region Register information
    HOTEL_CODE: "호텔 코드",
    STAR_RATING: "별점",
    HOTEL_LOGO: "로고",
    CONTACT_PHONE: "전화번호",

    HOTEL_TYPE: "호텔 유형",
    COUNTRY: "국가",
    CITY: "도/시",
    DISTRICT: "동/읍/특별구",
    WARD: "동/읍",
    HOTEL_NAME: "호텔 이름",
    ADDRESS: "주소",
    MAP_LOCATION: "지도상의 위치",
    LONGITUDE: "경도",
    LATITUDE: "위도",
    //#endregion

    // LEFT MENU
    DASHBOARD: "대시보드",
    MANAGE: "관리",
    BOOK_ROOM: "객실 예약",
    ROOM_SALE: "객실 판매",
    ROOM_AVAILABLE_AND_PRICE: "재고 및 요금",
    SALE_AND_PROMOTION_PACKAGES: "판매 및 프로모션 패키지",
    SETTING: "설정",
    ACCOUNT_INFO: "계정 설정",
    ACCOUNT_SETTING: "개인 계정",
    USER_MANAGE: "사용자 관리",
    CONTRACT: "계약",
    HOTEL_INFOMATION: "호텔 설정",
    GENERAL_INFO: "일반 설정",
    TYPE_ROOM: "객실 유형",
    HOTEL_CONFIG: "구성",
    GALLERY_MANAGER: "사진 갤러리",
    TRAVEL_AGENT: "여행사",
    ACTIVITY_DAIRY: "시스템 로그",
    ACTIVITY_DIARY_UPDATE_BULK: "대량 로그 업데이트",
    ACTIVITY_DIARY_UPDATE_ROOM_AVAIL: "재고 로그 업데이트",
    SUPPORT: "지원",
    INSTRUCTION_DOCUMENT: "지침 문서",
    INSTRUCTION_DOCUMENT_CONNECT_BE: "웹사이트 통합",
    COPYED: "복사됨",
    VIEW_DEMO: "예약 엔진 페이지 보기",
    HOTLINE: "핫라인",
    BOOKING_LIST: "예약 목록",
    REQUEST_BOOKING_LIST: "예약 요청 목록",
    REVENUE_AND_EXPENDITURE_TRANSACTION: "거래",
    AGENT_LIST: "에이전트 목록",
    UNLINKED_LIST: "작업 중지 에이전트",
    PREVIEW_ON_BE: "예약 엔진 링크",
    PREVIEW_ON_TA: "TA 페이지 보기",
    SALE_CHANNEL: "채널",
    CHANNEL_GROUP: "채널 그룹",
    // END LEFT MENU

    SUNDAY: "일요일",
    MONDAY: "월요일",
    TUESDAY: "화요일",
    WEDNESDAY: "수요일",
    THURSDAY: "목요일",
    FRIDAY: "금요일",
    SATURDAY: "토요일",

    _DATE_RANGE: {
        SUNDAY: "일",
        MONDAY: "월",
        TUESDAY: "화",
        WEDNESDAY: "수",
        THURSDAY: "목",
        FRIDAY: "금",
        SATURDAY: "토",
        JAN: "1월",
        FEB: "2월",
        MAR: "3월",
        APR: "4월",
        MAY: "5월",
        JUN: "6월",
        JUL: "7월",
        AUG: "8월",
        SEP: "9월",
        OTC: "10월",
        NOV: "11월",
        DEC: "12월"
    },

    //#region PAYGATE
    _PAYGATE: {
        PAYMENT_THROUGH: "다음을 통한 결제",
        PAYMENT_METHOD: "결제 방법",
        ONLINE_PAYMENT_GATEWAY: "온라인 결제 게이트웨이",
        CONFIGURATION: "구성",
        CONFIG_PAYMENT_GATE: "결제 게이트웨이 설정",
        HOTEL: "호텔",
        TRANSFER_PAYMENT: "이체 결제",
        ONLINE_PAYMENT: "온라인 결제",
        PAYMENT_TYPE_EMPTY: "결제 유형이 없습니다",
        PAYMENT_METHOD_HAS_NOT_SELECTED: "결제 방법이 선택되지 않았습니다",
        PAYMENT_GATEWAY_IS_NOT_EXIST: "온라인 결제 게이트웨이가 선택되지 않았습니다",
        CASH: "현금 결제",
        DEBT: "부채 정산",
        PAYMENT_CARD: "결제 카드"
    },
    //#endregion

    // Hình ảnh phòng

    // End

    //#region nearby place
    NEAREST_POPULAR_LOCATION: "가장 가까운 인기 장소",
    MOST_POPULAR_LOCATION: "가장 인기 있는 장소",
    RESTAURANT_AND_MARKET: "레스토랑과 시장",
    TRAVEL_PLACE: "관광 명소",
    NEAREST_AIRPORT: "가장 가까운 공항",
    VIETNAMESE_NAME: "베트남어 이름",
    ENGLISH_NAME: "영어 이름",
    ADD_LOCATION: "위치 추가",
    DISTANCE: "거리",
    //#endregion

    //#region room information
    ROOM_INFOMATION: "객실 정보",
    ROOM_AMENITIES: "객실 편의 시설",
    ROOM_IMAGE: "객실 사진",
    ROOM_NAME: "객실 유형",
    ROOM_TYPE: "객실 유형",
    MEAL: "식사",
    NAME_ROOM_TYPE: "객실 유형 이름",
    NAME_ROOM_TYPE_DEFAULT: "제목 (기본값)",
    TOTAL_ROOM: "객실 수",
    MAX_CUSTOMER_COUNT: "최대 투숙 인원",
    ROOM_DIMENSION: "객실 크기",
    BED_BONUS_COUNT: "추가 침대 수",
    PRICE_NORMAL_DAY: "평일 요금",
    PRICE_WEEKEND: "주말 요금",
    ROOM_DIRECTION: "객실 방향",
    BED_TYPE: "침대 유형",
    ADULT: "성인",
    CHILDREN: "어린이",
    ACTION: "작업",
    COMMON_BED_TYPE: "일반 침대 유형",
    COMBINATION_BED_TYPE: "침대 유형 조합",
    MORE_OPTIONS: "추가 옵션",
    REMOVE_OPTIONS: "옵션 제거",
    ADD_TYPE_BED: "침대 유형 추가",
    FREE: "무료",
    SURCHARGE: "추가 요금",
    //#endregion

    //#region selling room
    PACKAGE: "패키지",
    SELLING_PACKAGE_INFO: "요금제 정보",
    SELLING_PACKAGE: "요금제",
    SERVICE_PACKAGE: "혜택 패키지",
    PROMOTION: "프로모션",
    PROMOTION_INFO: "프로모션 정보",
    NAME_SELLING_PACKAGE: "요금제 이름",
    PACKEAGE_APPLY_FOR: "판매 패키지 적용 대상",
    MEALS_INCLUDE: "포함된 식사",
    EXTRA_BED_PRICE: "추가 침대 요금",
    EXTRA_ADULT_PRICE: "추가 성인 요금",
    EXTRA_CHILD_PRICE: "추가 아동 요금",
    MIN_NIGHT: "최소 숙박 일수",
    MAX_NIGHT: "최대 숙박 일수",
    DAYS_NOT_APPLY: "적용되지 않는 날짜",
    NOT_APPLY: "적용 제외 날짜",
    ADD_DAYS_NOT_APPLY: "적용 제외 추가 날짜",
    TYPE_ROOM_APPLIED: "적용 가능한 객실 유형",
    PLAN_IS_SELECTING: "판매 패키지가 OTA에 연결되었습니다",
    PLAN_NULL: "요금제가 존재하지 않습니다",
    ERROR: "죄송합니다. 예기치 않은 오류가 발생했습니다. 나중에 다시 시도하십시오.",
    COPY_SUCCESS: "복사 성공",
    COPPY_SUCCESS: "복사 성공",
    NOT_SELECTED_PLAN: "선택된 요금제가 없습니다",
    NOT_SELECTED_ROOM: "선택된 객실이 없습니다",
    MAX_STAY_NOT_SMALL_THAN_MIN_STAY: "최대 숙박 일수는 최소 숙박 일수보다 작을 수 없습니다",
    CBALERT_LB_AVAISEARCH: "하나 이상 선택하십시오",

    PROMOTION_PACKAGE_NAME: "프로모션 이름",
    PROMOTION_TYPE: "프로모션 유형",
    APPLY: "적용",
    APPLY_WITH: "함께 적용",
    DISCOUNT_AND_SURCHARGES: "할인/추가 요금",
    DAYS_APPLY: "적용 요일",
    TIME_STAY: "체류 날짜",
    TIME_SET: "예약 날짜",
    TARGET_APPLY: "적용 대상",
    ARGENT_LEVEL_APPLY: "에이전트 레벨 선택",
    ARGENT_APPLY: "에이전트 선택",
    PACKAGE_APPLY: "요금제",
    X_DAYS: "x일",
    FROM_DATE: "부터",
    TO_DATE: "까지",
    MIN_COUNT: "최소 수량",
    NIGHT_STAY: "숙박 일수",
    ROOM_BOOK_QUANTITY: "객실 수",
    QUANTITY_IS_FREE: "무료 수량 (y)",
    COUPON: "쿠폰",
    STATUS: "상태",
    ACTIVE: "활성",
    DEACTIVE: "비활성",
    STATE_ACTIVE_OR_DEACTIVE: "활성/비활성",
    //#endregion

    //#region booking room
    CONTACT_BOOKING_DETAIL: "연락처 세부 사항",
    BOOKING_DETAIL: "예약 세부 사항",
    NORMAL_ROOM_DETAIL: "일반 객실 세부 사항",
    VIP_ROOM_DETAIL: "VIP 객실 세부 사항",
    SERVICES: "서비스",
    PAYMENT_HISTORY: "결제 이력",
    //#endregion

    //#region common
    FILE_NAME: "파일 이름",
    FILE_TYPE: "파일 유형",
    UPLOAD_BY: "업로드한 사람",
    FILE_CAPACITY: "파일 용량",
    SIZE: "크기",
    UPLOAD_TIME: "업로드 시간",
    CLOSE: "닫기",
    TOTAL: "총계",
    OR: "또는",
    CHOOSE: "선택",
    NO_PHOTOS_FOUND: "사진을 찾을 수 없습니다",
    //#endregion

    //#region upload controller
    DRAG_DROP_PHOTOS_HERE: "여기에 사진을 드래그 앤 드롭하세요",
    SELECT_PHOTOS_TO_UPLOAD: "업로드할 사진 선택",
    MAXIMUM_CAPACITY: "최대 용량",
    LOADING: "로딩 중",
    //#endregion

    //#region hotel setting
    EMAIL_CONFIGURATION: "이메일 설정",
    HOTEL_EMAIL: "호텔 이메일",
    EMAIL_RECEIVE_BOOKING_ALERT_CC: "알림 이메일",
    EMAIL_CO_RECEIVE_BOOKING_ALERT_CC: "알림 이메일 (참조 이메일)",
    EMAIL_RECEIVE_BOOKING_ALERT_BCC: "알림 이메일 (숨은 참조 이메일)",
    DISPLAY_LANGUAGE_AND_WEEKEND: "표시 언어 및 주말",
    DISPLAY_LANGUAGE: "언어",
    WEEKEND: "주말",
    CURRENCY_AND_TAXES_FEES: "통화 및 세금/추가 요금",
    CURRENCY_USED_IN_SYSTEM: "사용 통화",
    VAT_RATE_IS_APPLIES: "부가세(%)",
    SERVICE_TAX_RATE_APPLIES: "서비스 요금",
    PRICES_INCLUDE_TAXES_FEES: "세금/추가 요금 포함 가격",
    REGULATIONS_ON_CHILD_AGE_AND_ACCOMPANING_FEE: "아동 연령 및 동반 요금 규정",
    YOUTH_IS_FREE_OF_CHARGE: "유아 최대 연령",
    AGE_CHILD_EXTRA_CHARGE: "아동 최대 연령",
    OTHER_INFOMATION: "기타 정보",
    CHECKIN_TIME: "체크인 시간",
    CHECKOUT_TIME: "체크아웃 시간",
    YEAR_BUILT: "건축 연도",
    TOTAL_NUMBER_OF_FLOORS: "층 수",
    DISTANCE_TO_AIRPORT: "공항까지 거리",
    DISTANCE_TO_CITY_CENTER: "도심까지 거리",
    TIME_TO_AIRPORT: "공항까지 소요 시간 (분)",
    VOLTAGE_USED: "사용 전압",
    ROOM_SERVICE: "룸 서비스",
    HOTEL_RULES: "호텔 정책",
    //#endregion

    //#region payment policy
    EFFECTIVE_DATE: "적용일",
    DEPOSIT_BEFORE_CHECKIN: "체크인 전 보증금",
    PERCENT: "퍼센트",
    AMOUNT_OF_MONEY: "금액",
    PREPAYMENT_BEFORE_CHECKIN_DATE: "체크인 전 결제",
    PAYMENT_BEFORE_CHECKOUT_DATE: "체크아웃 시 결제",
    PAYMENT_BEFORE_DAY_CHECKIN_DATE: "체크인 당일 결제",
    ADD_NEW_PAYMENT_POLICY: "새 결제 정책 추가",
    DEPOSIT_LEVEL_APPLIES: "보증금 수준 적용",
    TIME_APPLICATION: "체류 날짜",
    //#endregion

    //#region cancellation policy
    CANCEL_ROOM_IN_ROUND_X_DAY_BEFORE_CHECKIN: "체크인 x일 전 예약 취소",
    FIXED_MONEY: "고정 금액",
    ADD_NEW_CANCELLATION_POLICY: "새 취소 정책 추가",
    FINES_APPLY: "벌금 적용",
    //#endregion

    //#region Header
    PERSONAL_ACCOUNT_SETTING: "개인 계정 설정",
    LOG_OUT: "로그아웃",
    FEEDBACK_SUCCESS: "피드백 성공",
    //#endregion

    _LOGIN: {
        LOGIN: "로그인",
        USERNAME: "사용자 이름",
        PASSWORD: "비밀번호",
        FORGOT_PASSWORD: "비밀번호를 잊으셨나요",
        REGISTER_NOW: "지금 등록",
        LOOKING_AGENT: "대리점을 찾고 계신가요?",
        LOGIN_HERE: "여기에서 로그인",
        INVALID_ACCOUNT_INFO_MESSAGE: "사용자 이름 또는 비밀번호가 잘못되었습니다!",
        SESSION_EXPIRED: "세션이 만료되었습니다!",
        HAS_NO_ACCESS: "로그인 계정이 유효하지 않습니다!",
        SESSION_EXPIRED_MESSAGE: "보안상의 이유로, 활동이 없는 일정 시간 후에 세션이 만료됩니다. 계속하려면 사용자 이름과 비밀번호를 입력하여 로그인하십시오.",
        ARE_YOU_FORGOT_PASSWORD: "비밀번호를 잊으셨나요?",
        ENTER_EMAIL_USERNAME: "비밀번호 재설정을 위해 이메일 또는 사용자 이름을 입력하십시오!",
        EMAIL_USERNAME: "이메일 또는 사용자 이름",
        EMAILADDRESS_ERROR_REQUIRED: "이메일을 다시 확인하십시오!",
        EMAIL_NOT_EXIST: "이메일 또는 사용자 이름이 존재하지 않습니다. 다시 시도하십시오!",
        REQUEST_RESET_PASS_NOTICE: "비밀번호 재설정 요청이 성공했습니다",
        SEND_NEW_PASS: "새 비밀번호가 전송되었습니다. 이메일을 확인하십시오!",
        CANCEL: "취소",
        RESET: "확인",
        HOTELID: "호텔 ID",
        EZID_LOGIN: "ezID로 로그인"
    },
    _RESET: {
        NOT_VALID_REQUEST: "비밀번호 재설정 요청이 더 이상 유효하지 않습니다"
    },
    _REGISTER: {
        OTA_GROUP: "판매 채널 그룹",
        OTA: "판매 채널",
        WELCOME: "ezCrs에 오신 것을 환영합니다 - 호텔을 위해 특별히 설계되었습니다",
        SOLOGAN: "오늘 저희와 함께 등록하고 시작부터 끝까지 도와드리겠습니다. 다양한 제품을 예약하고 고객에게 판매할 수 있습니다. 지금 바로 가입하세요!",
        PERSONAL_DETAIL: "개인 정보",
        HOTEL_DETAIL: "호텔 정보",
        CREATE_ACCOUNT: "계정 생성",
        ENTER: "입력",
        HOTEL_EMAIL: "호텔 이메일",
        ENTER_EMAIL: "이메일 입력",
        ENTER_TAX_CODE: "코드 입력",
        ENTER_ROOM_QUANTITY: "객실 수 입력",
        YOUR_COMPANY_NAME: "회사/브랜드명",
        YOUR_WEBSITE_LINK: "호텔 웹사이트 링크",
        SELECT: "선택",
        REQUIRED: "필수",
        FULLNAME: "성명",
        YOUR_FULLNAME: "전체 이름",
        PERSONAL_PHONE: "개인 전화번호",
        MALE: "남성",
        FEMALE: "여성",
        EMAIL: "이메일",
        YOUR_EMAIL: "귀하의 이메일",
        POSITION: "직위/직책",
        YOUR_POSITION: "직위/직책",
        HOTEL_NAME: "호텔 이름",
        HOTEL_TYPE: "호텔 유형",
        TAX_CODE: "세금 코드",
        COUNTRY: "국가",
        WARD: "동/읍",
        WEBSITE: "웹사이트",
        STAR: "별 등급",
        CITY: "도시/도",
        ADDRESS: "주소",
        HOTEL_PHONE: "호텔 전화번호",
        NUMBER_OF_ROOMS: "객실 수",
        DISTRICT: "동/읍/특별구",
        USERNAME: "사용자 이름",
        CREATE_NEW_ACCOUNT_NAME: "새 계정 이름 만들기",
        PASSWORD: "비밀번호",
        CREATE_PASSWORD: "비밀번호 생성",
        RETYPE_PASSWORD: "비밀번호 재입력",
        PASSWORD_NOT_MATCH: "비밀번호가 일치하지 않습니다",
        PHONE_NUMBER_NOT_LESS_THAN: "전화번호는 8자 이상이어야 합니다",
        PASSWORD_NOT_LESS_THAN: "비밀번호는 8자 이상이어야 합니다",
        VALID_USERNAME_MESSAGE: "문자와 숫자로만 구성된 사용자 이름을 선택하십시오",
        BY_CLICKING_REGISTER: "등록 버튼을 클릭함으로써 귀하는 당사의",
        TERM_AND_CONDITIONS: "약관",
        PRIVACY_POLICY: "개인정보 처리방침",
        AGREE_POLICY_MESSAGE: "등록 버튼을 클릭하면 약관 및 개인정보 처리방침에 동의하는 것입니다",
        THANKS_FOR_REGISTER: "등록해주셔서 감사합니다!",
        WAIT_APPROVE: "계정이 생성되었으며 승인 대기 중입니다.",
        UPLOAD_CERTIFICATE_MESSAGE: "계정을 확인하고 발급하기 위해 사업자 등록증을 업로드하십시오. 계정 확인은 48시간 이내에 이루어집니다.",
        REQUIRED_FIELD: "필수 항목",
        ACCOUNT_ALREADY_EXISTS: "계정이 이미 존재합니다",
        REGISTER: "등록",
        NEXT: "다음",
        BACK: "이전",
        UPLOAD_FILE: "파일 업로드",
        COMPLETE_AND_LOGIN: "완료하고 홈페이지로 돌아가기"
    },
    // support
    _SUPPORT: {
        TITLE: "웹사이트에 예약 엔진 통합 지침"
    },
    // 대시보드
    _DASHBOARD: {
        TITLE: "대시보드",
        IN_MONTH_REVENUE: "이번 달 수익 (VND)",
        SEVEN_DAY_REVENUE: "지난 7일 수익 (VND)",
        COLLECTION: "수취액 (VND)",
        ROOM_FILLING_RATE: "월별 객실 점유율",
        BOOKING_EMPTY: "새 예약이 여기에 표시됩니다",
        BOOKING_TIME: "예약 시간",
        BOOKING_CODE: "예약 코드",
        AGENCY: "대행사",
        TIME_STAY: "숙박 날짜",
        PACKAGE: "구독 패키지",
        TOTAL: "총계 (VND)",
        PAYMENT_STATUS: "결제 상태",
        BOOKING_NOT_PAYMENT: "미결제 예약",
        BOOKING_PART_PAYMENT: "부분 결제 예약",
        BOOKING_CANCELED: "고객이 취소한 예약",
        GO_TO_BOOKING_LIST: "전체 예약 보기",
        STATUS: "상태",
        HOTEL_STATUS: "호텔 정보",
        CONTRACT: "계약",
        DEBT: "부채",
        SYNC_PMS: "PMS 동기화",
        MISSING_INFO: {
            SYNC_OTA: "채널 동기화",
            SYNC_OTA_SUB_TITLE: "최소 1채널 OTA 동기화",
            LIMITATIONS: "제한 사항 선언",
            RESTRICTION_SUB_TITLE: "최소 1개의 제한 사항 선언",
            RATE_PLAN: "가격 및 객실 재고 선언",
            RATE_PLAN_SUB_TITLE: "최소 1채널 및 객실 재고의 최소값 선언",
            TITLE: "필수 정보 완료",
            HOTEL_INFO: "호텔 정보",
            HOTEL_INFO_SUB_TITLE: "필수 필드 작성",
            ROOM_TYPE: "객실 유형 정보",
            ROOM_TYPE_SUB_TITLE: "최소 1개의 객실 유형 선언",
            HOTEL_IMAGE: "호텔 사진",
            HOTEL_IMAGE_SUB_TITLE: "최소 1개의 이미지 업로드",
            ROOM_PRICE: "가격 계획",
            ROOM_PRICE_SUB_TITLE: "최소 1개의 가격 계획 선언",
            HOTEL_SETTING: "호텔 설정",
            HOTEL_SETTING_SUB_TITLE: "필수 필드 작성",
            BOOKING_CANCEL_POLICY: "취소 정책",
            BOOKING_CANCEL_POLICY_SUB_TITLE: "최소 1개의 정책 선언",
            PAYMENT_GATE: "결제 게이트웨이",
            PAYMENT_GATE_SUB_TITLE: "최소 1개의 결제 방법",
            CONTRACT: "계약",
            CONTRACT_SUB_TITLE: "필수 필드 작성",
            PAYMENT_POLICY: "결제 정책",
            PAYMENT_POLICY_SUB_TITLE: "최소 1개의 정책 선언",
            CLOSE: "닫기",
            ROOM_PLAN: "가격 계획",
            ROOM_PLAN_SUB_TITLE: "최소 1개의 객실 판매 패키지 선언",
            HOTEL_CONFIG: "호텔 설정",
            HOTEL_CONFIG_SUB_TITLE: "필수 필드 작성"
        },
        CONFIRM: "확인",
        CONFIRM_SELL_ROOM: "입력한 모든 정보가 정확하며 OneInventory에 판매용 객실을 게시하는 데 동의합니다",
        CONFIRM_SELL_ROOM_BUTTON: "판매용 객실 확인",
        _HOTEL_STATUS_INFO: {
            CREATE: "생성",
            WAIT_CONFIRM: "확인 대기",
            WAIT_APPROVE: "승인 대기",
            APPROVED: "승인됨",
            SENT_BACK: "반송됨",
            ONSITE: "현장",
            OFFSITE: "비현장"
        },
        _HOTEL_STATUS_CONTRACT: {
            NOT_CREATED: "생성되지 않음",
            CREATE: "생성",
            RELEASED: "발행됨",
            WAIT_SIGN: "서명 대기",
            COMPLETED: "완료",
            SIGNED: "서명됨",
            IN_DISPUTE: "분쟁 중",
            LIQUIDATED: "청산됨",
            CLOSED: "종료됨"
        },
        _HOTEL_STATUS_DEBT: {
            NOT_CONFIGURED: "구성되지 않음",
            CONFIGURED: "구성됨"
        },
        _HOTEL_STATUS_SYNC_PMS: {
            SYNCHRONIZED: "동기화됨",
            UNSYNCHRONIZED: "동기화되지 않음",
            RECEIVED: "수신됨",
            NOT_RECEIVED: "아직 수신되지 않음"
        },
    },
    // END
    _BATCH_UPDATE: {
        TITLE: "대량 업데이트",
        ADD: "추가",
        SELECT_ROOM_TYPE: "객실 유형 선택",
        SELECT_UPDATE_TYPE: "업데이트 유형 선택",
        ALL_ROOM: "모든 객실",
        AVAILABLE_ROOM: "재고",
        PRICE: "가격",
        STOP_SELL: "판매 중지",
        CTA: "도착 전",
        CTD: "출발 전",
        MIN_NIGHT_STAY: "최소 숙박일",
        MAX_NIGHT_STAY: "최대 숙박일",
        ROOM_TYPE_AND_SALE_PACKAGE: "객실 유형 / 요금 계획",
        FROM: "부터",
        TO: "까지",
        MESSAGE: {
            OVERLAP_TIME: "업데이트 시간 간격이 겹칠 수 없습니다."
        },
        APPLY: "적용",
        DELETE_STOP_SELL: "판매 중지 삭제",
        DELETE_CTA: "도착 전 삭제",
        DELETE_CTD: "출발 전 삭제"
    },
    // Booking
    _BOOKING: {
        TITLE: "예약 목록",
        BOOKING: "0 예약 | 1 예약 | {count} 예약",
        BOOKING_DATE: "예약 날짜",
        BOOKING_CODE: "예약 코드",
        REQUEST_CODE: "요청 코드",
        REQUEST_DATE: "요청 날짜",
        REQUEST_STATUS: "요청 상태",
        AGENT_NAME: "대행사",
        TIME_STAY: "숙박 날짜",
        COMBO: "구독 패키지",
        COMBO_REQUEST: "요청 패키지",
        AMOUNT: "총 금액",
        BOOKING_STATUS: "예약 상태",
        EXPORT: "엑셀 내보내기",
        SEARCH: "검색",
        RESET: "초기화",
        ENTER_BOOKING_CODE: "예약 코드 입력",
        ENTER_BOOKING_CODE_OTA: "OTA 예약 코드 입력",
        ENTER_BOOKING_GROUP_CODE: "단체 예약 코드 입력",
        SEARCH_CONDITION: "검색 기준",
        SEARCH_BOOKING_CODE: "예약 코드",
        SEARCH_DATE: "날짜 범위 선택",
        EDIT: "수정",
        CONFIRM_FEEDBACK: "대행사에 보낸 요청 확인",
        CONFIRM_FEEDBACK_REASON: "피드백 내용",
        SEARCH_BY: {
            BOOKING_CODE: "예약 코드",
            REQUEST_DATE: "요청 날짜",
            BOOKING_DATE: "예약 날짜",
            CHECKIN_DATE: "체크인 날짜",
            CHECKOUT_DATE: "체크아웃 날짜",
            STAYING_DATE: "숙박 날짜"
        },
        STATUS: {
            ALL: "전체",
            CANCEL: "고객 취소",
            AWAIT_PAYMENT: "결제 대기",
            CLOSE: "완료",
            IN_SERVICE: "서비스 중",
            PAYMENT_FAILED: "결제 실패",
            CONFIRM: "확인됨",
            AWAIT_FULLY_PAYMENT: "부분 결제",
            VOID: "호텔 취소",
            STATUS_WAIT_FEEDBACK: "피드백 대기",
            STATUS_FEEDBACK: "피드백",
            STATUS_COMPLETE: "완료",
            STATUS_CANCEL: "취소됨"
        },
        SEARCH_PMS_STATUS: "동기화 상태",
        SEARCH_PMS_CODE: "PMS 유형",
        CHECKIN_STATUS: "체크인 상태",
        AGENT: "TA",
        MARKET: "시장 세그먼트",
        PDF: "PDF 내보내기",
        UNMAP_BOOKING: {
            UNMAP_BOOKING_TITLE: "Mapping status",
            ALL: "All",
            MAPPED: "Mapped",
            UNMAP_ROOM_TYPE: "Unmapped room",
            UNMAP_RATE_PLAN: "Unmapped rate",
            UNMAP_ROOMRATE: "Unmapped room_rate",
        }
    },
    _BOOKING_DETAIL: {
        TITLE: "예약 상세 정보",
        CONTACT: {
            TITLE: "연락처",
            NAME: "고객 이름",
            PHONE: "전화번호",
            EMAIL: "이메일",
            GROUP_NAME_TOUR: "그룹 이름",
            AGENT_NAME: "대행사"
        },
        BOOKING_DETAIL: {
            TITLE: "예약 정보",
            CODE: "예약 코드",
            OTACODE: "OTA 예약 코드",
            STATUS: "예약 상태",
            CREATED: "예약 날짜",
            CHECK_IN: "체크인 날짜",
            CHECK_OUT: "체크아웃 날짜",
            UPDATED: "업데이트 날짜",
            NOTE: "메모"
        },
        ROOM: {
            TITLE: "객실 정보 -",
            APPLY_DATE: "날짜",
            NAME: "요금 계획",
            UNIT_PRICE: "가격 / 박 (VND)",
            QUANTITY: "객실 수",
            ADULTS: "성인",
            CHILDREN: "어린이",
            BABY: "유아",
            TOTAL: "금액 (VND)"
        },
        PROMOTION_ONEI: {
            TITLE: "프로모션 One Inventory",
            NAME: "프로모션 이름",
            COST_TYPE: "비용 유형",
            TOTAL: "금액 (VND)"
        },
        PROMOTION: {
            TITLE: "프로모션",
            NAME: "프로모션 이름",
            ROOM_PLAN_NAME: "요금 계획",
            ROOM_NAME: "객실 유형",
            TOTAL: "금액 (VND)"
        },
        SERVICE: {
            TITLE: "서비스",
            NAME: "서비스 이름",
            DATE: "사용 날짜",
            COST: "가격",
            COUNT: "수량",
            TOTAL: "금액 (VND)"
        },
        PAYMENT_LOG: {
            TITLE: "결제 내역",
            METHOD: "결제 방법",
            AMOUNT: "금액",
            TRANS_NO: "거래 코드",
            TRANS_DATE: "거래 날짜",
            RES_CODE: "결과",
            RES_MSG: "메모"
        },
        METHOD_NAME: {
            ONEPAY_DOM: "국내 Onepay 결제",
            ONEPAY_INTER: "국제 Onepay 결제",
            VNPAY: "Vnpay 결제",
            TRANSFER: "이체 결제",
            CASH: "현금 결제",
            VNPAY_QR: "Vnpay QR 결제",
            VIETTELPAY_QR: "Viettelpay QR 결제",
            VIETTELPAY: "Viettelpay 결제"
        },
        PAYMENT_CARD_DETAIL: "결제 카드 상세 정보",
        SUB_TOTAL: "합계",
        TOTAL: "총 금액",
        PAID: "결제된 금액:",
        UNPAID: "미결제 금액:",
        EXPORT: "예약 출력",
        CANCEL: "예약 취소",
        NOTE: "메모",
        CONFIRM_CANCEL: "예약 취소를 확인하시겠습니까?",
        CONFIRM_REASON: "이유 (필수)",
        CONFIRM: "확인",
        COMMISSION: "수수료",
        BEFORE_COMMISSION: "수수료 제외 금액",
        AFTER_COMMISSION: "수수료 포함 금액",
        PAYMENT_COLLECT: "지불 수집",
        PROPERTY_COLLECT: "자산 수집",
        OTA_CONTACT: "OTA 연락처",
        CHANNEL_COLLECT: "채널 수집"
    },
    _REQUEST_DETAIL: {
        TITLE: "요청 상세 정보",
        BUGET: "지불된 예산",
        CONTACT: {
            TITLE: "예약 연락처 정보",
            NAME: "고객 이름",
            PHONE: "전화번호",
            EMAIL: "이메일",
            AGENT_NAME: "대행사",
            REQUESTER_NAME: "요청자 이름"
        },
        BOOKING_DETAIL: {
            TITLE: "요청 정보",
            CODE: "요청 코드",
            STATUS: "요청 상태",
            CREATED: "요청 날짜",
            CHECK_IN: "체크인 날짜",
            CHECK_OUT: "체크아웃 날짜",
            UPDATED: "업데이트 날짜"
        },
        ROOM: {
            TITLE: "객실 정보",
            APPLY_DATE: "날짜",
            NAME: "요금 계획",
            UNIT_PRICE: "가격 / 박 (VND)",
            QUANTITY: "객실 수",
            ADULTS: "성인",
            CHILDREN: "어린이",
            TOTAL: "금액 (VND)"
        },
        NOTE: "메모",
        SEND_REQUEST: "피드백"
    },
    _BOOKING_TRANSACTION: {
        TITLE: "수익 및 지출 거래",
        ALL: "전체",
        BOOKING: "예약",
        BOOKING_DATE: "예약 날짜",
        BOOKING_CODE: "예약 코드",
        AGENT_NAME: "대행사",
        TIME_STAY: "숙박 날짜",
        AMOUNT: "총 금액",
        PAYMENT_DATE: "결제 날짜",
        BOOKING_STATUS: "예약 상태",
        ACTION: "작업",
        EXPORT: "엑셀 내보내기",
        SEARCH: "검색",
        CONFIRM: "확인",
        TIME_STAY_TEXT: "{day}일 {night}박",
        SEARCH_CONDITION: "검색 기준",
        SEARCH_BOOKING_CODE: "코드 입력",
        SEARCH_DATE: "날짜 범위",
        SEARCH_BY: {
            BOOKING_CODE: "예약 코드",
            BOOKING_DATE: "예약 날짜",
            CHECKIN_DATE: "체크인 날짜",
            CHECKOUT_DATE: "체크아웃 날짜"
        },
        STATUS: {
            CANCEL: "고객 취소",
            AWAIT_PAYMENT: "결제 대기",
            CLOSE: "완료",
            IN_SERVICE: "서비스 중",
            PAYMENT_FAILED: "결제 실패",
            CONFIRM: "확인됨",
            AWAIT_FULLY_PAYMENT: "부분 결제",
            VOID: "호텔 취소"
        }
    },
    _BOOKING_TRANSACTION_DETAIL: {
        TITLE: "거래 상세 정보",
        DETAIL: "거래 상세 정보",
        BOOKING_CODE: "예약 코드:",
        PAYMENT_METHOD: "결제 방법",
        TRANSACTION_CODE: "거래 코드",
        TRANSACTION_DATE: "거래 날짜",
        AMOUNT: "금액",
        NOTE: "메모",
        BANK_TRANSFER: "이체",
        CASH: "현금",
        DEBT: "부채"
    },
    // END

    // Sale room plan
    _ROOM_PLAN: {
        TITLE: "객실 및 요금 계획",
        BATCH_UPDATE: "대량 업데이트",
        ALL_ROOM: "모든 객실",
        STOP_SELL: "판매 중지",
        MIN_STAY: "최소 숙박일",
        MAX_STAY: "최대 숙박일",
        CTA: "도착 전",
        CTD: "출발 전",
        CURRENT_MONTH: "{month}/{year}",
        CONFIRM_CHANGE_PAGE: "저장되지 않은 데이터는 손실됩니다\n계속 진행하시겠습니까?",
        MIN_SMALLER_THAN_ONE: "최소 숙박일은 1일보다 적을 수 없습니다",
        MAX_SMALLER_THAN_ONE: "최대 숙박일은 1일보다 적을 수 없습니다",
        MIN_BIGGER_THAN_MAX: "최소 숙박일이 최대 숙박일보다 더 깁니다",
        MIN_SMALLER_THAN_CONFIG: "최소 숙박일이 설정된 최소 숙박일보다 작습니다",
        MAX_BIGGER_THAN_CONFIG: "최대 숙박일이 설정된 최대 숙박일보다 큽니다"
    },
    // END

    SALE_PACKAGE: "Rate plan",
    // Hotel chain
    _HOTEL_CHAIN: {
        CHAIN_LIST_HOTEL: "호텔",
        TITLE: "호텔 체인",
        CHAIN_NAME: "체인 이름",
        CHAIN_LIST: "호텔 목록 ({total})",
        HOTEL_ID: "호텔 ID: ",
        ADD_HOTEL: "호텔 추가",
        LOGIN_TEXT: "호텔을 변경하려면 호텔 소유자 계정으로 로그인하십시오",
        LOGIN_EXISTED_TEXT: "계정 로그인 {hotelName}:",
        USERNAME: "사용자 이름",
        PASSWORD: "비밀번호",
        CONFIRM: "확인",
        REMOVE_HOTEL: "선택한 호텔을 체인에서 제거하시겠습니까?",
        LOGIN: "로그인",
        DELETE_HOTEL: "체인에서 제거",
        LABEL_SEARCH_CODE_NAME: "호텔 코드/이름",
        ENTER_HOTEL_NAME_OR_CODE: "호텔 이름 또는 코드 입력",
        CHAIN_LIST_BOOKING: "예약",
        STATUS: "상태",
        SEARCH: "검색"
    },

    // END

    // Tài khoản cá nhân
    _ACCOUNT_SETTING: {
        TITLE: "개인 계정 설정",
        AVATAR: "아바타",
        USER_INFO: "개인 정보",
        CHANGE_PASSWORD: "비밀번호 변경",
        USERNAME: "사용자 이름",
        FULLNAME: "성명",
        PASSWORD: "비밀번호",
        PASSWORD_REPEAT: "비밀번호 확인",
        GENDER: "성별",
        GENDER_MALE: "남성",
        GENDER_FEMALE: "여성",
        EMAIL: "이메일",
        PHONE_NUMBER: "전화번호",
        ADDRESS: "주소",
        POSITION: "직위",
        GROUP: "사용자 그룹",
        CURRENT_PASS: "현재 비밀번호",
        NEW_PASS: "새 비밀번호",
        NEW_PASS_REPEAT: "새 비밀번호 확인",

        ERROR_PHONE_NUMBER_MIN: "전화번호는 최소 8자 이상이어야 합니다",
        ERROR_PASSWORD_MIN: "비밀번호는 최소 8자 이상 입력해야 합니다",
        ERROR_RETYPE_PASSWORD_MIN: "비밀번호 확인은 최소 8자 이상 입력해야 합니다",
        ERROR_PASSWORD_INVALID: "현재 비밀번호가 올바르지 않습니다",
        ERROR_PASSWORD_NOT_MATCH: "비밀번호가 일치하지 않습니다",
        MESSAGE_PASSWORD_MATCHED: "비밀번호가 일치합니다",
        MESSAGE_PASSWORD_NOT_MATCHED: "비밀번호가 일치하지 않습니다"
    },
    // END
    _LIST_USER: {
        TITLE: "사용자 관리",
        LIST_USER: "사용자",
        USER: "사용자",
        SEARCH_PLACEHOLDER: "사용자 이름, 성명 또는 이메일로 검색",
        GROUP_NAME: "그룹 이름",
        USERNAME: "사용자 이름",
        NAME: "성명",
        EMAIL: "이메일",
        CREATE_USER: "생성자",
        CREATE_DATE: "생성일",
        STATUS: "상태",
        ACTION: "작업",
        STATUS_ACTIVATE: "활성",
        STATUS_DEACTIVATE: "비활성",
        REMOVE: "이 사용자를 삭제하시겠습니까?",
        CANNOT_DELETE_CURRENT_USER: "현재 사용자를 삭제할 수 없습니다"
    },
    // Quản lý nhóm người dùng - danh sách
    _LIST_GROUP: {
        TITLE: "사용자 그룹 관리",
        LIST_GROUP: "사용자 그룹",
        GROUP: "사용자 그룹",
        SEARCH_PLACEHOLDER: "사용자 그룹 이름으로 검색",
        GROUP_NAME: "그룹 이름",
        CREATE_USER: "생성자",
        CREATE_DATE: "생성일",
        STATUS: "상태",
        ACTION: "작업",
        STATUS_ACTIVATE: "활성",
        STATUS_DEACTIVATE: "비활성",
        DESCRIPTION: "설명 정보",
        REMOVE: "이 그룹을 삭제하시겠습니까?"
    },
    // END
    // Quản lý người dùng - Thêm/sửa
    _EDIT_USER: {
        TITLE: "사용자 정보",
        INFO: "사용자 정보",
        USER: "사용자",
        ROLE: "접근 권한",
        USERNAME: "사용자 이름",
        FULLNAME: "성명",
        PASSWORD: "비밀번호",
        PASSWORD_REPEAT: "비밀번호 확인",
        GENDER: "성별",
        GENDER_MALE: "남성",
        GENDER_FEMALE: "여성",
        EMAIL: "이메일",
        PHONE_NUMBER: "전화번호",
        ADDRESS: "주소",
        POSITION: "직위",
        GROUP: "사용자 그룹",
        GROUP_PLACEHOLDER: "검색",
        HOTEL_OWNER: "호텔 관리자",
        STATUS: "활성/비활성 상태",
        N_O: "번호",
        FUNCTION_CODE: "기능 코드",
        FUNCTION_NAME: "기능 이름",
        ACTION: "작업",
        ERROR_PHONE_NUMBER_MIN: "전화번호는 최소 8자 이상이어야 합니다",
        ERROR_PASSWORD_MIN: "비밀번호는 최소 8자 이상 입력해야 합니다",
        ERROR_RETYPE_PASSWORD_MIN: "비밀번호 확인은 최소 8자 이상 입력해야 합니다",
        ERROR_PASSWORD_NOT_MATCH: "비밀번호가 일치하지 않습니다",
        CHAIN: "체인",
        HOTEL: "호텔"
    },
    // END

    // Quản lý nhóm người dùng - Thêm/sửa
    _EDIT_GROUP: {
        TITLE: "사용자 그룹 정보",
        INFO: "사용자 그룹 정보",
        GROUP: "사용자 그룹",
        ROLE: "접근 권한",
        GROUP_NAME: "그룹 이름",
        GROUP_CODE: "그룹 코드",
        GROUP_ROLE: "그룹 역할",
        PARENT_GROUP: "상위 그룹",
        TYPE: "그룹 유형",
        DESCRIPTION: "설명 정보",
        STATUS: "활성/비활성 상태",
        NO: "번호",
        FUNCTION_CODE: "기능 코드",
        FUNCTION_NAME: "기능 이름",
        ACTION: "작업",
        ERROR_MIN_ROLE_SELECTED: "최소 1개의 기능 화면을 선택하십시오"
    },
    // END

    // Hợp đồng điện tử
    _CONTRACT: {
        TITLE: "전자 계약",
        CONTRACT_INFO: "법적 정보",
        BUSINESS_NAME: "회사 이름",
        BUSINESS_NAME_NOTE: " (사업자 등록증에 정확히 기재, 대문자)",
        TAX_CODE: "세금 코드",
        TAX_CODE_NOTE: " (정확히 입력하고 모든 0 포함)",
        ADDRESS: "등록 사업 주소",
        ADDRESS_NOTE: " (GPKD에 따라 작성)",
        BANK_ACCOUNT: "은행 계좌 번호",
        BANK_ACCOUNT_OWNER: "계좌 소유자 이름",
        BANK: "은행 이름",
        BANK_BRANCH: "은행 지점",
        LEGAL_REPRESENTATIVE: "법적 대리인",
        LEGAL_REPRESENTATIVE_NOTE: " (GPKD에 따라 작성)",
        PIC: "계약 서명자",
        PIC_POSITION: "서명 직위",
        COMMISSION: "커미션 (%)",
        STATUS: "계약 상태",
        VIEW: "보기",
        _STATUS: {
            CREATE: "생성",
            AM_SENT: "AM 발송",
            SM_ACCEPT: "SM 승인",
            SM_REJECT: "SM 거부",
            CM_ACCEPT: "CM 승인",
            CM_REJECT: "CM 거부",
            PUBLISH: "공개",
            WAIT_SIGN: "서명 대기",
            COMPLETE: "완료",
            SIGNED: "서명됨",
            DISPUTED: "분쟁",
            LIQUIDFY: "청산",
            CLOSE: "종료",
            EXTEND: "연장"
        }
    },
    // END

    // Danh sách đại lý hợp tác
    _TRAVEL_AGENT: {
        TITLE: "대리점 목록",
        TITLE_DEACTIVE: "협력 중지 대리점 목록",
        AGENT: "대리점",
        SEARCH_PLACEHOLDER: "대리점 이름으로 검색",
        NAME: "대리점 이름",
        BUSINESS_TYPE: "사업 유형",
        TAX_CODE: "세금 코드",
        LEVEL: "분류 에이전트",
        STATUS: "상태",
        DEACTIVE: "연결 해제",
        ACTIVE: "연결 복구",
        LEVEL_1: "레벨 1",
        LEVEL_2: "레벨 2",
        LEVEL_3: "레벨 3",
        LEVEL_4: "레벨 4",
        LEVEL_5: "레벨 5",
        CONFIRM_CHANGE_LEVEL: "레벨 변경을 확인하시겠습니까?",
        CONFIRM_ACTIVE: "대리점 연결을 확인하시겠습니까?",
        CONFIRM_DEACTIVE: "대리점 연결 해제를 확인하시겠습니까?",
        CONFIRM_REASON: "사유 (필수)",
        CONFIRM: "확인"
    },
    // END
    _VALIDATE: {
        REQUIRED: "필수 정보를 모두 입력하십시오",
        EMAIL_FORMAT: "이메일 형식을 확인하십시오",
        MIN_LENGTH: "입력 값은 {minLength}자 이상이어야 합니다",
        MAX_LENGTH: "입력 값은 {maxLength}자 이하여야 합니다",
        REQUIRED_AT_LEAST_ONE_HOTEL_OR_CHAIN: "사용자에게 하나 이상의 체인 또는 호텔을 선택하십시오"
    },

    /* beautify preserve:start */
    _ROLES: {
        CHAIN: "체인 메뉴",
        BOOKING_CHAIN: "체인 및 호텔 예약",
        CHAIN_LIST: "체인 목록",
        // USER_GROUP: "USER_GROUP",
        USER_MANAGEMENT: "사용자 관리",
        DASHBOARD: "대시보드",
        MANAGE: "관리",
        BOOKING_HOTEL: "단일 호텔 예약",
        ROOM_SALE: "객실 판매",
        ROOM_SALE_MANAGEMENT: "객실 판매 관리",
        SALE_PACKAGE_MANAGEMENT: "요금제 관리",
        OTA_MANAGEMENT: "ezCms Vela",
        SETTING: "설정",
        ACCOUNT_INFOMATION: "계정 구성",
        PERSONAL_ACCOUNT: "개인 계정 정보",
        GENERAL_INFORMATION: "일반 정보",
        HOTEL_AMENITY: "호텔 편의시설",
        HOTEL_IMAGE: "호텔 이미지",
        NEARBY_PLACE: "주변 장소",
        ROOM_TYPE: "객실 유형",
        ROOM_INFORMATION: "객실 정보",
        ROOM_AMENITY: "객실 편의시설",
        ROOM_IMAGE: "객실 이미지",
        HOTEL_CONFIGURATION: "호텔 설정",
        GENERAL_CONFIGURATION: "일반 설정",
        PAYMENT_POLICY: "결제 정책",
        CANCELLATION_POLICY: "취소 정책",
        IMAGE_LIBRARY: "이미지 라이브러리",
        HISTORY_LOG: "이력 로그",
        PAYMENT_METHOD: "결제 방법",
        BOOKING_ENGINE: "예약 엔진",
        BOOKING_ENGINE_CONFIG: "구성",
        HOTEL_EMAIL: "이메일",
        HOTEL_BOOKING_CONFIRM: "예약 확인",
        HOTEL_SERVICE: "서비스",
        HOTEL_PROMOTION: "프로모션",
        HOTEL_INFORMATION: "호텔 정보",
        BOOKING_MANAGEMENT: "예약 관리",
        SYNC_MANAGEMENT: "채널 동기화",
        HEADER_FOOTER: "템플릿",
        SU_MANAGEMENT: "ezCms Leo",
        SU_CONNECTION: "판매 채널",
        SU_MAPPING: "매핑",
        HOTEL_BOOKING_REPOST: "예약 재게시",
        CHAIN_SERVICE: "서비스",
        CHAIN_ROOM_TYPE: "객실 유형 정보",
        CHAIN_RATE_PLAN: "객실 판매 패키지",
        CHAIN_TRAVEL_AGENT: "회사 및 에이전트 정보",
        HOTEL_TRAVEL_AGENT: "회사 및 에이전트 정보",
        SITEMINDER_MANAGEMENT: "ezCms SiteMinder",
        GDS_MANAGEMENT: "ezCms GDS",
        RMS_MANAGEMENT: "수익 관리",
        DYNAMIC_PRICING: "동적 요금",
        MASTER_RATE: "기본 요금",
        PACKAGE_MANAGEMENT: "패키지 거래",
        PACKAGE_ITEM: "패키지 항목",
        PACKAGE_DEAL: "패키지 거래",
        BE_MANAGEMENT: "ezBe",
        HOTEL_BOOKING_GROUP: "예약 그룹",
        BOOKING_UNMAP_HOTEL: "미매핑 예약",
        HOTEL_DASHBOARD_IGNORE_TASK: "무시",
        HOTEL_DASHBOARD_REUPDATE_TASK: "재업데이트",
        HOTEL_BOOKING_UNMAP_REPOST: "예약 재게시",
        CHAIN_ROOM_UPDATE_QUANTITY: "객실 수 업데이트",
        HOTEL_DASHBOARD: "대시보드",
        ROOM_UPDATE_QUANTITY: "객실 수 업데이트",
        DYNAMIC_RESTRICTION: "동적 제한",
        DYNAMIC_ROOM_SALE: "동적 객실 판매",
        DYNAMIC_CONFIGURATION: "구성",
        CHAIN_BOOKING_REPOST: "예약 재게시",
        INVENTORY: "재고",
        RATE: "가격",
        RESTRICTION: "제한",
        STOP_SELL_LIMIT: "판매 제한",
        CHANNEX_MANAGEMENT: "ezCms Vela+",
        CHANNEX_CONNECTION: "판매 채널",
        CHANNEX_MAPPING: "매핑",
        WARNING_METHOD: "경고 방법",
        STAAH_MANAGEMENT : "ezCms StaahMax",
        STAAH_MAPPING: "매핑",
        STAAH_CONNECTION: "판매 채널",
    },

    _LEFT_MENU: {
        COPY_RIGHT: "Copyright © 2021 ezCloud 모든 권리 보유"
    },
    _ACTIVITY: {
        ACTION_DATE: "작업 날짜",
        ACTION_BY: "작업자",
        APPLY_DATE: "적용 날짜",
        CREATED_DATE: "생성 날짜",
        ROOM_NAME: "객실 이름",
        RATE: "요금",
        CREATE_DATE: "생성 날짜",
        SEARCH_DATE: "적용 날짜",
        USER_NAME: "계정",
        ROOM: "객실",
        ROOM_PLAN: "요금제",
        YES: "예",
        NO: "아니오",
        STOPSELL: "판매 중지",
        MINSTAY: "최소 숙박",
        CLOSEDTOARRIVE: "도착 불가",
        MAXSTAY: "최대 숙박",
        CLOSEDTODEPATURE: "출발 불가",
        IPADDRESS: "IP 주소",
        CREATEDBY: "생성자",
        PAGING: "페이지",
        DOCUMENT: "기록",
        ROOMAVAIL: "재고",
        ALLSELECT: "전체 선택",
        HOTELID: "호텔 ID",
        HOTELNAME: "호텔 이름",
        DATABEFORE: "이전 데이터",
        DATAAFTER: "이후 데이터",
        ACTION: "작업",
        HOTEL_LOGIN: "로그인",
        HOTEL_CANCEL_BOOKING: "예약 취소",
        HOTEL_UPDATE_PAYMENT_BOOKING: "예약 확인",
        HOTEL_REQUEST_BOOKING: "예약 요청 확인",
        HOTEL_ROOM_PLAN_CREATE: "새 요금제",
        HOTEL_ROOM_PLAN_UPDATE: "요금제 정보",
        HOTEL_ROOM_PLAN_COPY: "요금제 복사",
        HOTEL_ROOM_PLAN_DELETE: "요금제 삭제",
        HOTEL_PROMOTION_CREATE: "새 프로모션",
        HOTEL_PROMOTION_UPDATE: "프로모션 정보",
        HOTEL_PROMOTION_COPY: "프로모션 복사",
        HOTEL_PROMOTION_DELETE: "프로모션 삭제",
        HOTEL_PROFILE_UPDATE: "프로필 업데이트",
        HOTEL_AVATAR_ADD: "아바타 추가",
        HOTEL_AVATAR_REMOVE: "아바타 삭제",
        HOTEL_CHANGE_PASSWORD_PROFILE: "비밀번호 변경",
        HOTEL_USER_CREATE: "사용자 생성",
        HOTEL_USER_UPDATE: "사용자 업데이트",
        HOTEL_USER_UPDATE_ROLE: "사용자 역할 업데이트",
        HOTEL_USER_DELETE: "사용자 삭제",
        HOTEL_GROUP_CREATE: "사용자 그룹 생성",
        HOTEL_GROUP_UPDATE: "사용자 그룹 업데이트",
        HOTEL_GROUP_UPDATE_ROLE: "사용자 그룹 역할 업데이트",
        HOTEL_GROUP_DELETE: "사용자 그룹 삭제",
        HOTEL_CONTRACT_UPDATE: "계약 업데이트",
        HOTEL_INFO_UPDATE: "호텔 정보 업데이트",
        HOTEL_UPDATE_AMENITIES: "편의시설 업데이트",
        HOTEL_UPDATE_IMAGES: "이미지 추가",
        HOTEL_DELETE_IMAGES: "이미지 삭제",
        HOTEL_AREA_CREATED: "주변 지역 생성",
        HOTEL_AREA_UPDATED: "주변 지역 업데이트",
        HOTEL_AREA_DELETED: "주변 지역 삭제",
        HOTEL_CHAIN_CREATED: "호텔 체인 생성",
        HOTEL_CHAIN_UPDATED: "호텔 체인 업데이트",
        HOTEL_ROOM_CREATED: "객실 생성",
        HOTEL_ROOM_UPDATED: "객실 업데이트",
        HOTEL_ROOM_COPY: "객실 복사",
        HOTEL_ROOM_DELETED: "객실 삭제",
        HOTEL_ROOM_AMENITY: "객실 편의시설 업데이트",
        HOTEL_ROOM_ADD_IMAGES: "객실 이미지 추가",
        HOTEL_ROOM_DELETE_IMAGES: "객실 이미지 삭제",
        HOTEL_UPDATE_HOTEL_SETTING_INFO: "호텔 설정 정보 업데이트",
        HOTEL_PAYMENT_POLICY_CREATED: "결제 정책 생성",
        HOTEL_PAYMENT_POLICY_UPDATED: "결제 정책 업데이트",
        HOTEL_PAYMENT_POLICY_DELETED: "결제 정책 삭제",
        HOTEL_CANCEL_POLICY_CREATED: "취소 정책 생성",
        HOTEL_CANCEL_POLICY_UPDATED: "취소 정책 업데이트",
        HOTEL_CANCEL_POLICY_DELETED: "취소 정책 삭제",
        HOTEL_SETTING_PAYMENT_GATE: "결제 게이트 설정",
        HOTEL_ADD_IMAGES_SLIDE: "이미지 슬라이드 추가",
        HOTEL_DELETE_IMAGES_SLIDE: "이미지 슬라이드 삭제",
        HOTEL_REMOVE_CONNECT_AGENT: "에이전트 연결 취소",
        HOTEL_UPDATE_LEVEL_AGENT: "에이전트 연결 수준 업데이트",
        HOTEL_RETURN_CONNECT_AGENT: "에이전트 연결 복원",
        PMS_CONFIRM: "PMS 확인",
        RATE_CATEGORY_CREATE: "새 가격 범주 생성",
        RATE_CATEGORY_UPDATE: "가격 범주 세부 사항",
        ROOM_CATEGORY_CREATE: "새 객실 범주 생성",
        ROOM_CATEGORY_UPDATE: "객실 범주 세부 사항"

    },
    STATUS_CREATE_NEW: "새로 만들기",
    STATUS_DELIVERED: "배송됨",
    STATUS_SALE_SEND_HOTEL: "호텔로 발송",
    STATUS_SALE_ADMIN_SEND_BACK: "SM 반송",
    STATUS_SALE_ADMIN_PASSED: "SM 승인",
    STATUS_QC_SENT_BACK_HOTEL: "QC 반송",
    STATUS_QC_PASSED_HOTEL: "QC 승인",
    STATUS_SALE_ADDITIONAL: "정보 발송",
    STATUS_QC_SENT_BACK_INFOR: "정보 반송",
    STATUS_QC_PASSED_INFOR: "정보 승인",
    STATUS_ONSITE: "현장",
    STATUS_OFFSITE: "비현장",

    STATUS_SIGNED: "서명됨",
    STATUS_WAITING_SIGN: "서명 대기",
    STATUS_CLOSED: "종료됨",
    STATUS_IN_DISPUTE: "분쟁 중",
    STATUS_LIQUIDATED: "청산됨",
    STATUS_COMPLETED: "완료됨",
    STATUS_CM_PASSED: "CM 승인",
    STATUS_CM_SEND_BACK: "CM 반송",
    STATUS_RELEASED: "해제됨",
    STATUS_RENEWAL: "갱신됨",
    STATUS_CHANGED: "상태가 변경됨",
    STATUS_NEW_CREATE: "새로 만들기",

    STATUS_AWAIT_PAYMENT: "결제 대기",
    STATUS_AWAIT_FULLY_PAYMENT: "전체 결제 대기",
    STATUS_PAYMENT_FAILED: "결제 실패",
    STATUS_CONFIRM: "확인",

    ALL: "전체",
    CANCEL: "고객에 의해 취소됨",
    AWAIT_PAYMENT: "결제 대기 중",
    IN_SERVICE: "서비스 중",
    PAYMENT_FAILED: "결제 실패",
    CONFIRM: "확인됨",
    AWAIT_FULLY_PAYMENT: "부분 결제",
    VOID: "호텔에 의해 취소됨",
    STATUS_WAIT_FEEDBACK: "피드백 대기",
    STATUS_FEEDBACK: "피드백",
    STATUS_COMPLETE: "완료됨",
    STATUS_CANCEL: "취소됨",

    BOOKING: "예약",
    BOOKING_STATUS: "예약 상태",
    BOOKING_REQUEST_STATUS: "요청 상태",
    CONTRACT_STATUS: "계약 상태",
    TA_STATUS: "여행사 상태",
    HOTEL_STATUS: "호텔 상태",
    SHOW_MORE: "더 보기",
    NOTIFICATION: "알림",
    HAS_JUST_JOINED_ONEI: "One Inventory에 가입했습니다",
    HAS_JUST_CREATED_ONEI: "OneInventory.com에 생성했습니다",
    ANNEX_OF_CONTRACT: "계약 부록 번호",
    YOUR_AGENT: "귀하의 에이전트",
    NOTIFICATIONS: "알림",
    MARK_AS_READ: "읽음으로 표시",
    CONTACT_NUMBER: "계약 번호",
    HOTELS_CONTRACT: "호텔 계약",
    AGENTS_CONTRACT: "여행사 계약",
    ADDENDUM_OF_CONTRACT: "계약 추가 조항 번호",
    EXTEND_CONTRACT: "계약 연장",
    BELONG_HOTEL: "호텔 소속",
    BELONG_AGENT: "에이전트 소속",
    AGENT: "에이전트",
    NEW_TA: "새로운 에이전트",
    RE_RELEASE: "다시 출시",
    AGO: "전",
    MONTHS: "개월",
    YEARS: "년",
    SECONDS: "초",
    MINUTES: "분",
    HOURS: "시간",
    NOW: "지금",
    DAYS: "일",
    REQUEST_EMPTY: "요청이 비어 있습니다",
    STATUS_INCORRECT: "상태가 올바르지 않습니다",
    STATUS_CONTRACT_INCORRECT: "계약 상태가 올바르지 않습니다",
    NO_NOTIFICATION: "새로운 알림이 없습니다",
    ADDENDUM_STATUS: "추가 조항 상태",
    OVER_CHARACTER: "문자 수를 초과했습니다",
    HOTEL_LOG_bookingCode: "예약 ID",
    HOTEL_LOG_agentName: "에이전트 이름",
    HOTEL_LOG_customer: "고객 이름",
    HOTEL_LOG_createdDate: "생성일",
    HOTEL_LOG_checkinDate: "체크인 날짜",
    HOTEL_LOG_checkoutDate: "체크아웃 날짜",
    HOTEL_LOG_totalCost: "총 비용",
    HOTEL_LOG_payableAmount: "지불 금액",
    HOTEL_LOG_bookingStatus: "예약 상태",
    HOTEL_LOG_active: "활성",
    HOTEL_LOG_amount: "금액/비율",
    HOTEL_LOG_cancellationDay: "취소 일자",
    HOTEL_LOG_cancellationType: "취소 유형",
    HOTEL_LOG_startDate: "시작일",
    HOTEL_LOG_endDate: "종료일",
    HOTEL_LOG_hotelId: "호텔 ID",
    HOTEL_LOG_type: "적용 시간",
    HOTEL_LOG_notifyToEmail: "이메일",
    HOTEL_LOG_notifyCCEmail: "CC 이메일",
    HOTEL_LOG_notifyBCCEmail: "BCC 이메일",
    HOTEL_LOG_includeTaxesInPrice: "가격에 세금 포함",
    HOTEL_LOG_language: "언어",
    HOTEL_LOG_weekend: "주말",
    HOTEL_LOG_email: "이메일",
    HOTEL_LOG_checkinAfterHour: "이후 체크인",
    HOTEL_LOG_checkoutBeforeHour: "이전에 체크아웃",
    HOTEL_LOG_roomServices: "룸 서비스",
    HOTEL_LOG_hotelPolicyVi: "호텔 정책 VI",
    HOTEL_LOG_hotelPolicyEn: "호텔 정책 EN",
    HOTEL_LOG_yearOfBuild: "건축 연도",
    HOTEL_LOG_numberOfFloors: "층 수",
    HOTEL_LOG_numberOfRooms: "객실 수",
    HOTEL_LOG_minutesToAirport: "공항까지 분",
    HOTEL_LOG_babyAgeDetermine: "유아 연령 기준",
    HOTEL_LOG_childAgeDetermine: "아동 연령 기준",
    HOTEL_LOG_electronicVoltage: "전압",
    HOTEL_LOG_distanceToAirport: "공항까지 거리",
    HOTEL_LOG_serviceTaxPercent: "서비스 세율",
    HOTEL_LOG_valueAddedTaxPercent: "부가가치세 비율",
    HOTEL_LOG_distanceToCenter: "중심까지 거리",
    HOTEL_LOG_lat: "위도",
    HOTEL_LOG_lng: "경도",
    HOTEL_LOG_phoneNum: "전화 번호",
    HOTEL_LOG_hotLine: "핫라인",
    HOTEL_LOG_starRanking: "별점",
    HOTEL_LOG_website: "웹사이트",
    HOTEL_LOG_addressVi: "주소 VI",
    HOTEL_LOG_addressEn: "주소 EN",
    HOTEL_LOG_hotelNameVi: "호텔 이름 VI",
    HOTEL_LOG_hotelNameEn: "호텔 이름 EN",
    HOTEL_LOG_hotelTypeVi: "호텔 유형 VI",
    HOTEL_LOG_hotelTypeEn: "호텔 유형 EN",
    HOTEL_LOG_cityVi: "도시 VI",
    HOTEL_LOG_countryVi: "국가 VI",
    HOTEL_LOG_locationVi: "지역 VI",
    HOTEL_LOG_cityEn: "도시 EN",
    HOTEL_LOG_areaVi: "지역 VI",
    HOTEL_LOG_countryEn: "국가 EN",
    HOTEL_LOG_locationEn: "지역 EN",
    HOTEL_LOG_areaEn: "지역 EN",
    HOTEL_LOG_descriptionVi: "설명 VI",
    HOTEL_LOG_descriptionEn: "설명 EN",
    HOTEL_LOG_depositType: "보증금 유형",
    HOTEL_LOG_cutOfDate: "입금 마감일",
    HOTEL_LOG_paymentDay: "결제 마감일",
    HOTEL_LOG_proNameVi: "프로모션 이름 VI",
    HOTEL_LOG_proNameEn: "프로모션 이름 EN",
    HOTEL_LOG_promoType: "유형",
    HOTEL_LOG_sessionType: "세션 유형",
    HOTEL_LOG_discountOrSurcharge: "할인/할증 비율",
    HOTEL_LOG_coupon: "쿠폰",
    HOTEL_LOG_orderType: "적용 유형",
    HOTEL_LOG_notApplyDates: "적용 불가 날짜",
    HOTEL_LOG_applyPlans: "적용 계획",
    HOTEL_LOG_applyAgents: "적용 에이전트",
    HOTEL_LOG_applyLevels: "적용 레벨",
    HOTEL_LOG_applyDays: "적용 요일",
    HOTEL_LOG_bookType: "예약 유형",
    HOTEL_LOG_fromDays: "부터",
    HOTEL_LOG_toDays: "까지",
    HOTEL_LOG_minOrder: "최소 주문",
    HOTEL_LOG_freeForMinOrder: "최소 주문 무료",
    HOTEL_LOG_percentOrFixed: "비율 또는 고정",
    HOTEL_LOG_startBook: "예약 시작일",
    HOTEL_LOG_endBook: "예약 종료일",
    HOTEL_LOG_objectType: "객체 유형",
    HOTEL_LOG_delete: "삭제",
    HOTEL_LOG_promotionNameVi: "프로모션 이름 VI",
    HOTEL_LOG_promotionNameEn: "프로모션 이름 EN",
    HOTEL_LOG_promotionDesVi: "설명 VI",
    HOTEL_LOG_promotionDesEn: "설명 EN",
    HOTEL_LOG_code: "요청 ID",
    HOTEL_LOG_note: "비고",
    HOTEL_LOG_requestStatus: "요청 상태",
    HOTEL_LOG_fullName: "전체 이름",
    HOTEL_LOG_gender: "성별",
    HOTEL_LOG_phoneNumber: "전화번호",
    HOTEL_LOG_position: "직위",
    HOTEL_LOG_address: "주소",
    HOTEL_LOG_maxChildren: "최대 어린이 수",
    HOTEL_LOG_maxAdults: "최대 성인 수",
    HOTEL_LOG_totalRoom: "총 객실 수",
    HOTEL_LOG_defaultPrice: "기본 가격",
    HOTEL_LOG_weekendPrice: "주말 가격",
    HOTEL_LOG_roomSize: "객실 크기",
    HOTEL_LOG_numberOfExtraBeds: "추가 침대 수",
    HOTEL_LOG_bedTypeTitleVi: "객실 이름 VI",
    HOTEL_LOG_bedTypeTitleEn: "객실 이름 EN",
    HOTEL_LOG_viewVi: "객실 전망 VI",
    HOTEL_LOG_viewEn: "객실 전망 EN",
    HOTEL_LOG_bedTypeVi: "침대 유형 VI",
    HOTEL_LOG_bedTypeEn: "침대 유형 EN",
    HOTEL_LOG_sellAllotment: "할당량",
    HOTEL_LOG_roomName: "객실 유형",
    HOTEL_LOG_amenityName: "객실 편의시설",
    HOTEL_LOG_id: "코드",
    HOTEL_LOG_nameVi: "이름 VI",
    HOTEL_LOG_nameEn: "이름 EN",
    HOTEL_LOG_adultsIncluded: "포함된 성인 수",
    HOTEL_LOG_exAdult: "추가 성인 요금",
    HOTEL_LOG_aexType: "성인 유형",
    HOTEL_LOG_childrenInclued: "포함된 어린이 수",
    HOTEL_LOG_exChild: "추가 어린이 요금",
    HOTEL_LOG_cexType: "어린이 유형",
    HOTEL_LOG_start: "시작 날짜",
    HOTEL_LOG_end: "종료 날짜",
    HOTEL_LOG_sesType: "체류 시간",
    HOTEL_LOG_minStay: "최소 숙박 일수",
    HOTEL_LOG_maxStay: "최대 숙박 일수",
    HOTEL_LOG_extraBedPrice: "추가 침대 요금",
    HOTEL_LOG_rooms: "객실 유형",
    HOTEL_LOG_meals: "식사 포함",
    HOTEL_LOG_plans: "계획 이름",
    HOTEL_LOG_promotions: "프로모션 이름",
    HOTEL_LOG_avatar: "아바타",
    HOTEL_LOG_userName: "사용자 이름",
    HOTEL_LOG_userGroup: "사용자 그룹",
    HOTEL_LOG_owner: "소유자",
    HOTEL_LOG_name: "이름",
    HOTEL_LOG_functions: "기능 코드",
    HOTEL_LOG_users: "계정",
    HOTEL_LOG_description: "설명",
    HOTEL_LOG_enterpriseName: "기업 이름",
    HOTEL_LOG_registeredAddress: "기업 주소",
    HOTEL_LOG_taxCode: "세금 코드",
    HOTEL_LOG_bankAccountNumber: "은행 계좌 번호",
    HOTEL_LOG_bankAccountName: "은행 계좌 이름",
    HOTEL_LOG_bankName: "은행 이름",
    HOTEL_LOG_bankBranch: "은행 지점",
    HOTEL_LOG_representative: "대표자",
    HOTEL_LOG_signer: "서명자",
    HOTEL_LOG_area: "지역",
    HOTEL_LOG_location: "위치",
    HOTEL_LOG_city: "도시",
    HOTEL_LOG_country: "국가",
    HOTEL_LOG_hotline: "핫라인",
    HOTEL_LOG_images: "이미지 이름",
    HOTEL_LOG_amenities: "편의시설 이름",
    HOTEL_LOG_landmark: "랜드마크",
    HOTEL_LOG_distance: "거리",
    HOTEL_LOG_unit: "단위",
    HOTEL_LOG_hotelChains: "호텔 체인",
    HOTEL_LOG_roomId: "객실 ID",
    HOTEL_LOG_views: "조회수",
    HOTEL_LOG_agentId: "에이전트 ID",
    HOTEL_LOG_areas: "지역 이름",
    HOTEL_LOG_level: "에이전트 레벨",
    HOTEL_LOG_userGroups: "사용자 그룹 이름",
    HOTEL_LOG_hotelType: "호텔 유형",
    HOTEL_LOG_logo: "호텔 로고",
    HOTEL_LOG_currency: "통화",
    HOTEL_LOG_pmsConfirm: "PMS",
    HOTEL_LOG_restriction: "제한 사항",
    //
    OTHER_POLICY: "기타 정책",
    IF_CANCELED: "예약을 취소하는 경우",
    DAYS_PRIOR_TO_ARRIVAL_DATE: "도착일 전 며칠 이내",
    OF_THE_BOOKING_VALUE_WILL_CHARGED: "예약 금액의 일부가 청구됩니다",
    WILL_BE_CHARGED: "청구됩니다",
    WILL_BE_CHARGED_POCUP: "청구됩니다",
    RESERVATIONS: "예약",
    REQUIES_A_DEPOSIT: "보증금이 필요합니다",
    OF_THE_BOOKING_VALUE: "예약 금액의",
    THE_REMAINING_AMOUNT: "잔여 금액은",
    THE_REMAINING_DAYS: "잔여 금액은 체크인 전에 지불해야 합니다",
    PAYMENT_WHEN_CHECKIN: "체크인 전 결제",
    PAYMENT_WHEN_CHECKOUT: "체크아웃 전 결제",
    VIEWDETAIL_PHOTO: "사진 더 보기",
    PAYMENT_100: "예약 금액의 100% 결제",
    CANCEL_100: "취소 시 예약 금액의 100%가 청구됩니다",
    FREE_DEPOSIT: "무료 보증금",
    ARRIVAL_DATE: "도착 날짜",
    LEAVING_DATE: "출발 날짜",
    CHIlDRENTS: "어린이들",
    CHIlDRENT: "어린이",
    ADULTS: "성인",
    FREE_CANCEL: "무료 취소",
    CHARGE: "추가 요금이 부과됩니다",
    CHARGE_AS_ADULTS: "성인 요금으로 부과됩니다",
    CHILDREN_BELOW: "어린이 (미만)",
    CHILDREN_OVER: "어린이 (이상)",
    CHILDREN_FROM: "어린이 (부터)",
    AGES: "세",
    DISCOUNT: "할인",
    READ_MORE: "자세히 보기",
    READ_LESS: "간략히 보기",
    PICTURE_FACILITIES: "사진 & 시설",
    CAPACITY: "수용 인원",
    OPTIONS: "객실 계획",
    ALL_CAPACITY: "모든 시설 보기",
    UN_ALL_CAPACITY: "간략히 보기",
    PAYMENT_BEFORE: "결제 전",
    NO_PAYMENT_BEFORE: "선불 결제 필요 없음",
    BOOK_WITHIN: "내에서 예약",
    PAYMENT_100_NOW: "예약 금액의 100% 결제",
    CANCEL_FREE_FROM: "취소 무료 기간",
    TO_H: "우선 순위",
    CANCEL_FREE_BEFORE: "이전에 취소하면 취소 요금이 없습니다",
    FROM: "부터",
    UNTIL: "까지",
    EARLY_CONFIRM: "빠른 확인!",
    SEND_REQUEST_BOOKING: "예약 요청 제출",
    SEND_REQUEST_CART: "요청 추가",
    SEND_REQUEST_NOW: "지금 요청 제출",
    AREA_INFO: "지역 정보",
    CANCELLATION_POLICY: "취소 정책",
    CHILD_AND_BED: "어린이 및 침대 정책",
    IF_CANCELED_BEFORE: "이전에 취소 시",
    THERE_ARE: "다음이 있습니다",
    ROOM_TYPES_WITH: "객실 유형",
    OPTIONS_DETAIL: "객실 계획",
    SPECIAL_OFFER: "특별 제안",
    HOTEL_POLICY: "호텔 정책",
    CHECK_AVAILABILITY: "객실 검색",
    PRICE_FOR: "가격",
    ONLY: "단지",
    NIGHT: "박",
    ROOM_LEFT: "남은 객실",
    THE_PRICE_DOES_NOT_INCLUDE_VAT: "가격에 세금이 포함되지 않음",
    SERVICE_CHARGE: "서비스 요금",
    THE_PRICE_DOES_INCLUDE_VAT: "가격에 세금 포함",
    THE_PRICE_DOES_NOT_INCLUDE_VAT_NOT_TOOL: "세금 미포함",
    SERVICE_CHARGE_NOT_TOOL: "요금",
    THE_PRICE_DOES_INCLUDE_VAT_NOT_TOOL: "세금 포함",
    ADD_ROOM: "객실 추가",
    BOOK_NOW: "지금 예약",
    AND_SERVICE_CHARGE: "및 서비스 요금",
    AND_SERVICE_CHARGE_NOT_TOOL: "및 요금",
    NO_CHARGE: "요금 없음",
    ADULTS_BTN_RESULTSEARCH: "성인",
    ABOVE_12_YEARS: "12세 이상",
    CHILDRENS_BTN_RESULTSEARCH: "어린이",
    BELLOW_12_YEARS: "12세 이하",
    ROOM: "객실",
    HOW_OLD_ARE_THE_CHILDRENT: "어린이의 나이는 몇 살인가요?",
    CHECKIN: "체크인",
    CHECKOUT: "체크아웃",
    T2: "월",
    T3: "화",
    T4: "수",
    T5: "목",
    T6: "금",
    T7: "토",
    T8: "일",
    TH1: "1월",
    TH10: "10월",
    TH11: "11월",
    TH12: "12월",
    TH2: "2월",
    TH3: "3월",
    TH4: "4월",
    TH5: "5월",
    TH6: "6월",
    TH7: "7월",
    TH8: "8월",
    TH9: "9월",
    MOST_POPULAR: "가장 인기 있는 시설",
    EVERY_OPTION: "기타 시설",
    GIFT_CODE: "할인 코드",
    COPY_THIS_CODE: "이 코드를 복사하여 결제 페이지에 붙여넣으세요",
    ENDOW: "할인",
    APPLY_FOR_MIN_ORDER_FROM: "최소 주문 금액에서 적용",
    APPLY_ON_TOTAL_ROOM_RATE: "총 객실 요금에 적용",
    APPLY_ON_TOTAL_BOOKING: "총 예약 금액에 적용",
    APPLY_ON_TOTAL_SERVICE: "모든 서비스 요금에 적용",
    APPLY_ALL_ORDER: "모든 주문에 적용",
    NO_ROOM_LEFT: "객실 없음",
    QUIT_FAVORITE: "즐겨찾기에 추가됨",
    SUM_PROMOTION: "누적 프로모션",
    PRIORITY_PROMOTION: "우선 프로모션",
    BEST_PROMOTION: "최고의 프로모션",
    TYPE_PROMOTION: "프로모션 설정",
    INDEX: "색인",
    PMS_SUCCESS: '축하합니다. 호텔이 ezCrs에서 객실 판매를 완료했습니다',
    COMPLETE_INFOMATION: "정보 완성",

    // Module Service
    SERVICE: {
        CONFIRM_DELETE_SERVICE: "정말 삭제하시겠습니까?",
        CONFIRM_DEACTIVE_SERVICE: "정말 비활성화하시겠습니까?",
        SPECIAL_PRICE: "일일 요금",
        SPECIAL_PRICE_TITLE: "날짜",
        SPECIAL_PRICE_VALUE: "가격",
        ADD_SPECIAL_PRICE: "특별 가격 추가",
        HAS_EXITS: "이미 존재합니다",
        LINK: "링크 목록",
        STATUS_SYNC: "동기화 상태",
        ORDER: "주문",
        THUMBNAIL: "이미지",
        STATUS: "상태",
        DEACTIVE: "비활성",
        ACTIVE: "활성",
        SYNC_PMS: "PMS에서 동기화",
        LIST: "서비스 목록",
        INFO: "서비스 정보",
        NAME: "제목",
        DESCRIPTION_INFO: "설명",
        DESCRIPTION_INFO_DEFAULT: "설명",
        CODE: "서비스 코드",
        TIME_APPLY: "적용 시간",
        DAY_APPLY: "요일",
        DAYS_NOT_APPLY: "블랙아웃 날짜",
        ADD_DAYS_NOT_APPLY: "블랙아웃 날짜 추가",
        TIME_BOOK: "예약 날짜",
        TIME_USE: "숙박 날짜",
        FREE: "무료 서비스",
        PREMIUM: "유료 서비스",
        PRICE: "요금",
        PRICE_STATUS: "서비스 요금",
        INCLUDE_TAX: "세금 포함",
        CURRENCY: "통화",
        COPPY: "복사",
        UNIT: "단위",
        PER_BOOKING: "예약당",
        PER_PERSON_PER_NIGHT: "인당 1박",
        PER_ROOM: "객실당",
        PER_ROOM_PER_NIGHT: "객실당 1박",
        PER_PERSON: "1인당",
        TAX_LABEL: "세금",
        MAXBOOK: "최대 주문 수량",
        PACKAGE_SELL: "요금제",
        PACKAGE_ALL: "전체",
        PACKAGE_SPEC: "특정 요금제",
        SELL_CHANEL: "적용된 판매 채널",
        CHANEL_ALL: "모든 판매 채널에 적용",
        CHANEL_SPEC: "특정 판매 채널에 적용",
        CODE_MAX_LENGTH: "2자 이상이어야 합니다",
        SPECIAL_DESC: "특정 날짜의 가격",
        NOT_EMPTY: "비어 있을 수 없습니다",
        ERROR_DUPLICATE_DAY: "날짜가 겹칩니다. 다시 확인해주세요",
        TAX_DEFAULT: "기본값",
        UPDATE_IMAGE_SUCCESS: "이미지 업로드 성공",
        UPDATE_IMAGE_FAIL: "이미지 업로드 실패",
        CANCEL: "취소",
        NOTHUMB: "사진은 비워둘 수 없습니다",
        IMAGE_TOO_LARGE: "사진은 최대 8MB까지 가능합니다",
        BINDING_PRICE: "객실 요금에 포함",
        MAXQUATITY: "최대 서비스 수량",
        UNLIMIT: "무제한",
        LIMIT: "제한",
        ONE_TIME: "1회",
        CONFIRM_ACTIVE_SERVICE: "확인하시겠습니까?",
        BENEFIT: "혜택 및 유틸리티",
        MANDATORY_ADD_ON: "필수 추가 항목",
        MANDATORY_ADD_ON_INFO: "선택한 경우 예약이 완료될 때 서비스가 자동으로 적용됩니다.",
    },
    IMAGE_NOT_EXIST: "아직 사진이 없습니다",
    IMAGE_SERVICE: "사진",

    _ROOM_SALE: {
        ROOM_TYPE: {
            ROOM_TYPE: "객실 유형",
            ROOM_CODE: "객실 코드",
            MAX_PERSON: "최대 인원",
            MAX_ADULT: "최대 성인",
            MAX_CHILD: "최대 어린이",
            MAX_KID: "최대 아기",
            ROOM_PARENT_TYPE: "부모 객실",
            ERROR_ROOM_CODE: "객실 코드는 중복될 수 없으며 비워둘 수 없습니다",
            ERROR_ROOM_PARENT: "선택한 객실은 현재 객실의 부모로 설정되어 있습니다"
        },
        EXPAND: "더보기",
        UNEXPAND: "간략히 보기",
        SELL_CHANNEL: "채널",
        SELL_MARKET: "시장",
        SELL_CHANNEL_ALL: "모든 채널",
        SELL_CHANNEL_SPEC: "특정 채널",
        SELL_MARKET_ALL: "모든 시장",
        SELL_MARKET_SPEC: "특정 시장",
        LABEL_SEARCH_CODE_NAME: "코드/객실 유형",
        ENTER_HOTEL_NAME_OR_CODE: "코드/객실 유형 입력",
    },
    _SALE_PACKAGE: {
        SALE_PACKAGE: "요금제",
        ADD_NEW: "새 요금제 추가",
        ENTER_SALE_PACKAGE_NAME_OR_CODE: "코드/요금제 입력",
        RATE_CATEGORY: "요금 카테고리",
        RATE_CATEGORY_ADD_NEW: "새 요금 카테고리 추가",
        ROOM_CATEGORY: "객실 카테고리",
        ROOM_CATEGORY_ADD_NEW: "새 객실 카테고리 추가"
    },
    ADD_NEW_ROOM: "새 객실 추가",
    ROOMS_PER_PAGE: "페이지당 객실 수",
    NOT_EMPTY: "값을 입력하세요",
    _SERVICE_PACKAGE: {
        AGE_MAX_CHILD: "최대 어린이 나이",
        AGE_MAX_BABY: "최대 아기 나이",
        DAY_APPLY_IN_WEEK: "요일",
        PAYMENT_POLICY: "결제 정책",
        CANCEL_POLICY: "취소 정책",
        APPLY_OBJECT: "대상",
        APPLY_CARD: "카드 유형",
        PACKAGE_CODE: "요금 코드",
        ADD_PAYMENT_POLICY: "결제 정책 추가",
        ADD_CANCEL_POLICY: "취소 정책 추가",
        SALE_PACKAGE_CODE: "요금 코드",
        ERROR_SALE_PACKAGE_CODE: "요금 코드는 중복될 수 없으며 비워둘 수 없습니다"
    },
    PACKAGE_PER_PAGE: "페이지당 패키지 수",
    ADD_RANGE_DAYS_NOT_APPLY: "블랙아웃 날짜 추가",
    NOT_APPLY_RANGE_DATE: "블랙아웃 날짜",
    ROOM_AVAILABLE: "재고",
    NO_ROOM_PARENT: "없음",
    ROOM_RATE: "객실 요금",
    ADD_SALE_PACKAGE: "요금제 추가",
    ADD_DATE_RANGE: "날짜 범위 추가",
    CONFIRM_DELETE_SALE_PACKAGE_DATE_RANGE: "날짜 범위를 삭제하시겠습니까?",
    SELECT_SALE_PACKAGE: "요금제 선택",
    LIST_SALE_PACKAGE_EMPTY: "요금제 목록이 비어 있습니다",
    VIEW_TABLE: "테이블로 보기",
    VIEW_CALENDAR: "캘린더로 보기",
    SELECT_ROOM_TO_VIEW: "객실을 선택하여 보세요",
    SHOW_ROOM_AVAIL: "사용 가능한 수량 보기",
    ROOM_CONNECTED_OTA: "객실이 OTA와 동기화되었습니다",
    RESTRICTION_PACKAGE: "제한 패키지",
    RESTRICTION: "제한",
    ENTER_RESTRICTION_NAME_OR_CODE: "제한 이름 또는 코드를 입력하세요",
    CONFIRM_DELETE_RESTRICTION: "제한 패키지를 삭제하시겠습니까?",
    RESTRICTION_INFOMATION: "제한 정보",
    CONFIG_RESTRICTION: "제한 설정",
    DEFAULT: "기본",
    ROOMTYPE: "객실 유형",
    ROOMPLAN: "요금제",
    RESTRICTION_NAME: "제한 이름",
    ADD_NEW_RESTRICTION: "새 제한 추가",
    METADATA: "업데이트 선택",
    RESTRICTION_BULK_UPDATE: "대량 업데이트",
    RESTRICTION_BULK_DELETE: "대량 삭제",
    ROOM_AVAIL: "재고",
    SELL_LIMIT: "판매 한도",
    STOP_SELL_LIMIT: "판매 중지 한도",
    PRICE: "요금",
    MANAGE_SYNC_OTA: "채널 동기화",
    MANAGE_ALIAS_OTA: "ezCms Vela",
    ALL_ROOM: "전체 객실",
    NOT_SELECT_SALE_PACKGE: "요금제를 선택하세요",
    DATA_INPUT_INVALID: "데이터가 유효하지 않습니다",
    UPDATE: "업데이트",
    SELECT_ROOM_APPLY: "객실 유형",
    SELECT_SALE_PACKAGE_APPLY: "요금제 선택",
    SPECIAL_PRICE: "일일 요금",
    ENTER_PRICE_AND_CHOSE_SALE_PACAKGE: "가격, 요금제가 비어 있습니다",
    minStay: "최소 숙박일",
    maxStay: "최대 숙박일",
    minStayArrival: "최소 도착일 숙박",
    maxStayArrival: "최대 도착일 숙박",
    minBookingWindow: "최소 예약 기간",
    maxBookingWindow: "최대 예약 기간",
    minBookingWindowByHour: "최소 예약 기간(시간 단위)",
    maxBookingWindowByHour: "최대 예약 기간(시간 단위)",
    exactStay: "정확한 숙박 기간",
    exactStayArrival: "정확한 도착일 숙박",
    fromCheckout: "체크아웃부터",
    cutOfTime: "마감 시간",
    closedOnArrival: "도착일에 닫힘",
    closedOnDeparture: "출발일에 닫힘",
    closed: "판매 중지",
    belongTo: "속한",
    appliedFor: "적용된",
    CHANNEL_APPLY: "채널",
    CHANNEL_EMPTY: "빈 채널",
    APPLY_FOR: "적용 대상",
    priceExtraAdult: "추가 성인 요금",
    priceExtraChild: "추가 어린이 요금",
    priceExtraBaby: "추가 아기 요금",
    DAY_SPECIAL: "일일 요금",
    SUN_SHORT: "일",
    MON_SHORT: "월",
    TUE_SHORT: "화",
    WED_SHORT: "수",
    THU_SHORT: "목",
    FRI_SHORT: "금",
    SAT_SHORT: "토",
    JAN_SHORT: "1월",
    FEB_SHORT: "2월",
    MAR_SHORT: "3월",
    APR_SHORT: "4월",
    MAY_SHORT: "5월",
    JUN_SHORT: "6월",
    JUL_SHORT: "7월",
    AUG_SHORT: "8월",
    SEP_SHORT: "9월",
    OCT_SHORT: "10월",
    NOV_SHORT: "11월",
    DEC_SHORT: "12월",
    NO_SELECT: "변경 없음",
    OPEN: "열기",
    CONFIRM_DELETE_SPECIAL_PRICE: "일일 요금 삭제 확인",
    CONFIRM_DELETE_SPECIAL_PRICE_EXTRA_ADULT: "일일 추가 성인 요금 삭제 확인",
    CONFIRM_DELETE_SPECIAL_PRICE_EXTRA_CHILD: "일일 추가 어린이 요금 삭제 확인",
    CONFIRM_DELETE_SPECIAL_PRICE_EXTRA_BABY: "일일 추가 아기 요금 삭제 확인",
    REMOVE_SPECIAL_PRICE: "일일 요금 삭제",
    NO_DATA: "데이터 없음",
    CURRENCY_OTA: "채널의 통화",
    ROOM_TYPE_ON_OTA: "OTA의 객실 유형",
    SALE_PACKAGE_ON_OTA: "OTA의 요금제",
    NUMBER_OF_PERSON: "인원 수",
    PACKAGE_TYPE: "패키지 유형",
    RATES: "요금",
    RATES_OSCILLATE: "추가 요금",
    REGULAR_PRICE: "정상 요금",
    SYNCED: "동기화됨",
    ROOM_CLOSED: "닫힘",
    NO_SALEPACKAGE_AVAIL: "요금제가 사용 불가",
    YES: "예",
    NO: "아니오",
    BOOKING_CUSTOMER_NAME: "고객 이름",
    BOOKING_EMPTY: "예약이 없습니다.",
    BOOKING_CHANNEL: "채널",
    BOOKING_HOTEL: "호텔",
    STT: "번호",
    BOOKING_IS_NOT_EXIST: "예약이 존재하지 않습니다",
    ADD_NEW_SALE_CHANNEL: "새 채널 추가",
    CONNECT: "연결",
    SELECT_SALE_CHANNEL: "채널 선택",
    PHONE_INVALID: "전화번호가 유효하지 않습니다",
    EMAIL_INVALID: "이메일이 유효하지 않습니다",
    LOGIN_NOW: "지금 로그인하세요!",
    POLICY_NAME: "정책 이름",
    POLICY_DESCRIPTION: "정책 설명",
    DESCRIPTION: "설명",
    APPLY_DAY: "적용일",
    DEPOSIT_UNIT: "단위",
    APPLY_FOR_STAYING: "숙박일 기준",
    APPLY_FOR_BOOKING: "예약일 기준",
    CHECKOUT_DATE: "체크아웃 날짜",
    CHECKIN_DATE: "체크인 날짜",
    BEFORE_CHECKIN_DATE: "체크인 전 날짜",
    BEFORE_CHECKOUT_DATE: "체크아웃 전 날짜",
    CANCEL_ROOM_IN_ROUND_X_DAY_BEFORE: "x일 전 예약 취소",
    NIGHT_CAP: "0박 | 1박 | {count}박",
    CHANGE_PASSWORD_REQUEST_NO_LONGER_WORK: "비밀번호 변경 요청이 더 이상 유효하지 않습니다!",
    MAXROOM_1000: "최대 객실 수는 1000개입니다",
    DATA_INPUT_MAX_100_PERCENT: "최대 값 100",
    DATA_INPUT_MAX_10_NIGHT: "최대 값 10박",
    DUPLICATE_CODE: "중복 코드",

    CREATE: "생성",
    BULK_UPDATE: "일괄 업데이트",
    SETUP_OTA: "OTA 설정",
    AUTH: "호텔 접근",
    RECEIVE_BOOKING_FROM_OTA: "OTA에서 예약 받기",
    UPDATE_INVENTORY: "PMS에서 재고 업데이트",
    RECEIVE_INVENTORY_UPDATE_FROM_PMS: "PMS에서 재고 업데이트 받기",
    PUSH_BOOKING_NOTIFICATION_TO_PMS: "PMS로 예약 알림 푸시",
    HOTEL_INFO: "호텔 정보",
    HOTEL_IMAGE: "호텔 이미지",
    HOTEL_AREA: "호텔 지역",
    HOTEL_AMENITY: "호텔 편의시설",
    HOTEL_CANCELLATION_POLICY: "호텔 취소 정책",
    HOTEL_SETTING: "호텔 설정",
    HOTEL_PAYMENT_POLICY: "호텔 결제 정책",
    SETUP_AND_MAPPING_TO_OTA: "OTA 설정 및 매핑",
    HOTEL_RATE_PLAN: "호텔 요금제",
    HOTEL_RESTRICTION: "호텔 제한 사항",
    HOTEL_ROOM_TYPE: "호텔 객실 유형",
    HOTEL_ROOM_TYPE_AMENITY: "호텔 객실 유형 편의시설",
    HOTEL_ROOM_TYPE_AVAILABILITY: "호텔 객실 유형 가용성",
    HOTEL_ROOM_RATE: "객실 요금",
    HOTEL_ROOM_TYPE_STOP_SELL: "호텔 객실 유형 판매 중지",
    HOTEL_ROOM_RATE_ADULT: "호텔 객실 요금 성인",
    HOTEL_ROOM_RATE_CHILD: "호텔 객실 요금 어린이",
    HOTEL_ROOM_RATE_BABY: "호텔 객실 요금 아기",
    HOTEL_ROOM_RATE_SPECIAL: "호텔 객실 요금 특별",
    STAFF_INFO: "직원 정보",
    STAFF_PASSWORD: "직원 비밀번호",
    STAFF_AVATAR: "직원 아바타",
    STAFF_LOGIN: "직원 로그인",
    HOTEL_REGISTER: "호텔 등록",
    CHANGE_STATUS: "상태 변경",
    LOG_ACTION: "행동",
    LOG_FUNCTION: "기능",
    LOG_CONTENT: "로그",
    LOG_DATE_CREATE: "생성 날짜",
    LOG_USERNAME: "사용자 이름",
    PRICE_ON_OTA: "OTA에서의 요금",
    PRICE_ON_DEFINED: "정해진 요금",
    STOP_SELL_TRIGGER: "판매 중지 트리거",
    DOWNLOAD: "다운로드",
    CONFIRM_CHANGE_STATUS_SALE_PACKAGE: "요금제가 OTA와 동기화되었습니다. 상태를 변경하시겠습니까?",
    CONFIRM_CHANGE_STATUS_ROOMTYPE: "객실 유형이 OTA와 동기화되었습니다. 상태를 변경하시겠습니까?",
    hotel_id: "호텔 ID",
    property_id: "속성 ID",
    // OTA_hotel_id: "ID Khách sạn",
    HOTEL_ROOM_TYPE_IMAGES: "객실 이미지",
    IMAGE_MANAGAMENT: "갤러리",
    UNIT: "단위",
    NEARBY_TYPE: "주변 유형",
    DIALOG_CONFIRM_DESC: "요금제 설정에 따라 제한된 업데이트를 진행하시겠습니까?",
    CANNOT_GET_INFO_FROM_OTA_1: "OTA와의 통신이 중단되었습니다.",
    CANNOT_GET_INFO_FROM_OTA_2: "1900 9013로 연락하시거나 hotro@ezcloud.vn으로 이메일을 보내주세요.",
    ROOMTYPE_HAS_NO_RATEPLAN: "객실 유형, 요금제 및 채널의 사전 설정된 조합을 입력해주세요.",
    MAX_LENGTH_10: "데이터는 10자 제한이 있습니다.",
    UPDATE_BY: "업데이트 한 사람",
    OTA_HAS_NO_RATEPLAN: "이 OTA에는 아직 요금제가 없습니다.",
    PRICE_IS_REQUIRED: "가격이 비어 있습니다.",
    HOTEL_ROOM_IS_OVER_LIMIT: "호텔 객실 수가 제한을 초과했습니다.",
    CONFIRM_DELETE_PROMOTION: "프로모션을 삭제하시겠습니까?",
    ADD_NEW_PROMOTION: "새 프로모션 추가",
    ADD_NEW_SERVICE: "새 서비스 추가",
    PRICE_EXTRA: "추가 요금",
    PERSON_NUMBER: "인원 수",
    DETAIL: "세부 사항",
    PRICE_AND_PERSON_IS_REQUIRED: "가격과 인원 수가 필요합니다.",
    CHOOSE_LANG_PAYMENT: "결제 방법 언어 선택",
    ENTER_CONTENT_SHOW: "표시할 내용을 입력하세요",
    CONFIG_BE: "예약 엔진",
    SAVE_SUCCESS: "저장 성공",
    CONFIGURE_OUGING_EMAIL: "이메일 전송",
    EMAIL_SEND: "이메일 주소",
    EMAIL_NAME_SEND: "표시 이름",
    SERVER_MAIL_ADDRESS: "SMTP 서버",
    CONNECTOR: "SMTP 포트",
    ENCRYPTION_TYPE: "보안 연결",
    AUTHENTICATON_CONNECTION: "인증 연결",
    EMAIL_TYPE: "이메일 유형",
    TEST_EMAIL_SENT: "테스트 이메일 전송",
    SENT_EMAIL_TEST: "테스트 이메일 보내기",
    EMAIL_SETTING_EXISTED: "이메일이 이미 존재합니다.",
    ERROR_MAIL: "오류",
    SUCCESS_MAIL: "이메일이 성공적으로 전송되었습니다.",
    UNIT_ROOM_PRICE: "객실 요금",
    FROM_CHECKOUT: "체크아웃 시부터",
    NON_REFUNDABLE: "환불 불가",
    GUEST_NAME: "게스트 이름",
    FROM_TIME: "시작 시간",
    TO_TIME: "끝 시간",
    PROMOTION_CODE: "프로모션 코드",
    SORT: "정렬",
    HAS_CONNECTED: "연결됨",
    GUEST: "게스트",
    COUPON_CODE: "쿠폰 코드",
    PAYMENT_REQUIRED_UPON_BOOKING: "예약 시 결제 필요",
    CONDITIONS: "조건",
    HOW_MUCH_PAYMENT_IS_MADE_BY_THE_GUEST_ON_THE_DAY_OF_BOOKING: "예약일에 게스트가 지불한 금액은 얼마인가요?",
    PERCENT_OF_TOTAL_ROOM_RATE: "총 객실 요금의 %",
    WHEN_DOES_THE_CUSTOMER_MAKE_THE_PAYMENT_FOR_THE_REMAINING_AMOUNT: "남은 금액은 언제 결제하나요?",
    WHAT_THE_PAYMENT_POLICY_FOR_THE_BOOKING_PERIOD: "예약 기간에 적용되는 결제 정책은 무엇인가요?",
    WHAT_DOES_PAYMENT_POLICY_APPLY: "결제 정책이 적용되는 숙박 기간은 언제인가요?",
    POLICY_SUMMARY: "정책 요약",
    PERCENT_BOOKING: "% 예약",
    WHEN_DOES_THE_CUSTOMER_MAKE_THE_PAYMENT: "게스트는 언제 결제하나요?",
    DATA_INPUT_MAX_24_HOUR: "데이터는 24시간 이내에 입력해야 합니다.",
    DAY: "날짜",
    HOUR: "시간",
    HOW_MUCH_DOES_THE_CUSTOMER_MAKE_PAYMENT: "게스트가 결제한 금액은 얼마인가요?",
    ON_THE_DAY_OF_CHECK_IN: "체크인 날짜에",
    ON_THE_DAY_OF_CHECK_OUT: "체크아웃 날짜에",
    PRICE_PER_NIGHT: "1박 요금",
    ON_THE_DATE_OF_BOOKING: "예약 날짜에",
    UPDATE_PRICE_NOTE: "가격 및 수량 데이터가 덮어씌워집니다. 마스터 객실 요금 업데이트는 자식 객실 요금에 영향을 미칩니다.",
    PROMOTION_TITLE: "프로모션 제목",
    FREE_CANCELLATION_ALLOWED: "무료 취소 허용",
    HOW_LONG_BEFORE_CHECK_IN_CAN_GUESTS_CANCEL_FOR_FREE: "체크인 전에 얼마나 일찍 게스트가 무료로 취소할 수 있나요?",
    DAY_BEFORE_CHECK_IN: "{day}일 전 체크인 전",
    ACCORDING_TO_CUSTOM: "맞춤형",
    HOW_MUCH_DO_GUESTS_HAVE_TO_PAY_WHEN_THEY_CANCEL_A_RERVATION_DAYS_PRIOR_TO_ARRIVAL: "게스트가 {day}일 이내에 예약을 취소할 경우 얼마를 지불해야 하나요?",
    HOW_MUCH_DO_GUESTS_HAVE_TO_PAY_WHEN_CANCELING_A_RESERVATION: "예약을 취소할 경우 게스트가 지불해야 하는 금액은 얼마인가요?",
    WHAT_THE_CANCEL_POLICY_FOR_THE_BOOKING_PERIOD: "예약 기간에 적용되는 취소 정책은 무엇인가요?",
    WHAT_DOES_CANCEL_POLICY_APPLY: "취소 정책이 적용되는 시기는 언제인가요?",
    HOW_MUCH_WILL_THE_CUSTOMER_HAVE_TOT_PAY_IF_THE_GUEST_CANCELS_ON_THE_CHECKIN: "게스트가 체크인 당일 예약을 취소하면 고객이 지불해야 하는 금액은 얼마인가요?",
    UTC: "시간대",
    ROOM_ARE_AVAILABLE_FROM_LESS_TO_MORE: "객실은 적은 수에서 많은 수로 제공됩니다.",
    TIME_ZONE_HOTEL: "호텔 시간대",
    BED_TYPE_SETTING: "침대 유형 설정",
    ROOM_TYPE_SETTING: "객실 유형 설정",
    OVER_MAX_GUEST: "객실 유형에서 허용된 최대 인원을 초과했습니다.",
    OVER_MAX_ADULTS: "객실 유형에서 허용된 최대 성인 수를 초과했습니다.",
    OVER_MAX_CHILDREN: "객실 유형에서 허용된 최대 어린이 수를 초과했습니다.",
    OVER_MAX_BABY: "객실 유형에서 허용된 최대 유아 수를 초과했습니다.",
    UNDER_MAX_ADULTS: "판매 패키지에서 허용된 최대 성인 수를 초과했습니다.",
    UNDER_MAX_CHILDREN: "판매 패키지에서 허용된 최대 어린이 수를 초과했습니다.",
    UNDER_MAX_BABY: "판매 패키지에서 허용된 최대 유아 수를 초과했습니다.",
    UNDER_MAX_QUANTITY: "전체 객실 수는 선언된 가용성을 초과할 수 없습니다.",
    BOOKING_ENGINE: "예약 엔진",
    TEXT_NOTIFY_EXPIRED: "귀하의 계정은 {channel} 채널과 연결된 유통 채널이 {date}에 만료되었습니다. 데이터는 OTA 채널로 동기화되지 않으므로 갱신해주세요.",
    TEXT_NOTIFY_WILL_EXPIRE: "귀하의 계정은 {channel} 채널과 연결된 유통 채널이 {date}에 만료됩니다. 데이터는 OTA 채널로 동기화되지 않으므로 갱신해주세요.",
    ROOM_AND_PACKAGES_FOR_SALE_ON_GOOOGLE: "구글 호텔 채널에서 판매되는 객실 및 패키지",
    HOTEL_LOG_roomTypeI18n: "객실 유형",
    HOTEL_LOG_lang: "언어",
    HOTEL_LOG_ratePlanI18n: "객실 패키지",
    HOTEL_LOG_otaI18n: "OTA",
    BE_CONNECT_REQUIRED: "예약 엔진 연결이 없습니다.",
    ACCESS_DENIED: "액세스 권한 없음",
    OTA_NOT_FOUND: "OTA를 찾을 수 없습니다.",
    HOTEL_SYNC: "호텔이 동기화되었습니다.",
    PASSWORD_SENT_SUCCESS: "비밀번호가 성공적으로 전송되었습니다.",
    CAN_NOT_DELETE: "객실 유형/판매 패키지가 OTA와 연결되어 있어 삭제할 수 없습니다.",
    BOOKING_NOT_CANCEL: "예약을 취소할 수 없습니다.",

    HEADER_FOOTER_CONFIG: "템플릿",
    MENU_EDIT: "메뉴 유형",
    MENU_NAME: "이름",
    MENU_CONFIG: "메뉴 표시",
    WIDGETS_EDIT: "위젯 유형",
    ADD_NEW_WIDGETS: "새 위젯 추가",
    WIDGETS_NOT_YET_DISPLAYED: "위젯이 아직 표시되지 않음",
    PARAMETERS: "기타 설정",
    LOGO_DISPLAYS: "URL 로고",
    TOP_HEADER_BACKGROUND: "헤더 상단 - 배경 색상",
    HEADER_BACKGROUND: "헤더 - 배경 색상",
    TEXT_HEADER_COLOR: "헤더 - 텍스트 색상",
    TEXT_HEADER_COLOR_ACTIVE: "주 색상",
    FOOTER_BACKGROUND: "푸터 - 배경 색상",
    TEXT_FOOTER_COLOR: "푸터 - 텍스트 색상",
    BACKGROUND_COPYRIGHT: "푸터 하단 - 배경 색상",
    ADD_NEW_MENU: "새 메뉴 추가",
    CONTENT_WIDGETS: "콘텐츠",
    TITLE: "제목",
    REFERENCE_SAMPLE: "참조 샘플",
    VI: "베트남어",
    EN: "영어",
    BIGGER_THAN_EQUAL: "이상",
    AND_MORE: "그리고 {count}개의 다른 옵션",
    ALL_AGENT: "모든 에이전트",
    GROUP_AGENT: "그룹 에이전트",
    SPECIFIC_AGENT: "특정 에이전트",
    CHOOSE_NOT_APPLY_AGENT: "프로모션이 적용되지 않는 에이전트 선택",
    CHOOSE_APPLY_AGENT: "프로모션이 적용되는 에이전트 선택",
    LIST_NOT_APPLY_AGENT: "프로모션이 적용되지 않는 에이전트 목록",
    LIST_APPLY_AGENT: "프로모션이 적용되는 에이전트 목록",
    SEARCH_NAME_AGENT: "이름 또는 에이전트 코드 입력",
    AGENT_TYPE: "유형",
    ENTERPRISE_AGENT: "기업 여행",
    ENTERPRISE_TRADING: "기업 거래",
    ENTERPRISE_API: "기업 API",
    LIST_AGENT: "여행 에이전트 목록",
    SUCCESS: "성공",
    CONFIG_CONNECT: "연결 구성",
    NO_RECORDS: "표시할 기록이 없습니다",
    QUANTITY: "수량",
    ROOM_PRICE: "객실 요금",
    EXTRA_ADULT: "추가 성인",
    EXTRA_CHILD: "추가 어린이",
    HOTEL_PROMOTION: "호텔 프로모션",
    GUEST_INFO: "게스트 정보",
    MAX_GUEST: "최대 게스트 수",
    MAX: "최대",
    BOOKING_INFO: "일반 정보",
    WRONG_DOMAIN: "잘못된 도메인 이름",
    FILE_NULL: "파일 업로드 오류",
    PLEASE_COMPLETE_THE_FIELDS_MARKED: "필수 정보란을 모두 작성해주세요",
    ADD_NEW_SOCIAL_NETWORK: "새 소셜 네트워크 추가",
    PRIMARY_TEXT_COLOR: "주 텍스트 색상",
    PRIMARY_BACKGROUND_COLOR: "주 배경 색상",
    TOP_HEADER_TEXT_COLOR: "상단 헤더 텍스트 색상",
    TOP_HEADER_BACKGROUND_COLOR: "상단 헤더 배경 색상",
    HEADER_TEXT_COLOR: "헤더 텍스트 색상",
    HEADER_BACKGROUND_COLOR: "헤더 배경 색상",
    FOOTER_TEXT_COLOR: "푸터 텍스트 색상",
    FOOTER_BACKGROUND_COLOR: "푸터 배경 색상",
    BOTTOM_FOOTER_TEXT_COLOR: "하단 푸터 텍스트 색상",
    BOTTOM_FOOTER_BACKGROUND_COLOR: "하단 푸터 배경 색상",
    BUTTON_TEXT_COLOR: "버튼 텍스트 색상",
    BUTTON_BACKGROUND_COLOR: "버튼 배경 색상",
    BUTTON_TEXT_COLOR_2: "버튼 텍스트 색상 2",
    BUTTON_BACKGROUND_COLOR_2: "버튼 배경 색상 2",
    CUSTOM: "맞춤형",
    URL: "링크",
    OTA_IS_OUT_OF_TIME: "OTA 채널이 아직 활성화되지 않았습니다",
    DATA_INPUT_MUST_BE_GREATER_THAN_0: "입력 데이터는 0보다 커야 합니다",
    HOTEL_EXTRA_RATE_UPDATE: "추가 요금 업데이트",
    HOTEL_EXTRA_RATE_DELETE: "추가 요금 삭제",
    DATE_OF_STAY_DOES_NOT_APPLY: "체류 날짜가 적용되지 않음",
    DATE_OF_BOOKING_DOES_NOT_APPLY: "설정된 날짜가 적용되지 않음",
    BOOKING_CODE_OTA: "OTA 예약 코드",
    HOTEL_WAS_CONNECTED_WITH_OTA: "호텔이 이미 OTA 채널에 연결되었습니다",
    ROOM_TYPE_OTA: "ezCms Leo",
    CONNECTED: "연결됨",
    NOT_CONNECTED: "연결되지 않음",
    MISSING_ROOM_AND_PRICE: "객실, 요금 및 제한 사항이 누락되었습니다",
    CONNECTED_OTA: "OTA 매핑",
    SYNC_IN_PROGRESS: "동기화 진행 중",
    CONNECTING: "연결 중",
    ROOM_AND_PRICE_PACKAGES_HAVE_NOT_BEEN_DECLARED: "객실 패키지 및 가격이 아직 선언되지 않았습니다",
    CONNECTION_FAILED: "연결 실패",
    SU_CONNECTION: "판매용 채널",
    SU_MAPPING: "매핑",
    CHANNEL_MANAGER_SYSTEM: "중앙 예약 시스템",
    ENTER_NAME_OR_CODE: "코드 또는 이름 입력",
    OTA_LOG: "동기화 로그",
    INVENTORY_LOG: "재고 로그",
    ERROR_LOG: "오류 로그",
    SOURCE: "소스",
    UPDATE_TIME: "업데이트 시간",
    RATE: "요금",
    STOP_SELL: "판매 중지",
    MIN_STAY: "최소 숙박일",
    MAX_STAY: "최대 숙박일",
    EXTRA_ADULT_RATE: "성인 추가 요금",
    EXTRA_CHILD_RATE: "어린이 추가 요금",
    FULL_UPDATE: "세부사항",
    UN_STOP_SELL: "판매 중지 해제",
    OPEN_RESERVATION: "예약 오픈",
    OPEN_CHECKOUT: "체크아웃 오픈",
    ERROR_PHONE_NUMBER_LENGTH: "전화번호는 최소 6자에서 최대 10자여야 합니다",
    ERROR_PHONE_NUMBER_STRING: "전화번호에 문자나 번호 앞에 0이 포함될 수 없습니다",
    FAILURE: "실패",
    ACTIVE_LOG: "활동 로그",
    WAITING: "진행 중",
    ROOM_SALE_UPDATE: "객실 판매 업데이트",
    PRICE_EXTRA_SPECIAL: "일일 추가 요금",
    BASE_PRICE_IS_MISSING: "기본 요금이 선언되지 않았습니다",
    TOOLTIP_MASTER: "가격 계산의 기준이 될 1개의 마스터 상품 라인을 선택하세요",
    RULE_CODE: "2-20자의 알파벳과 숫자만 포함된 코드",
    ROOM_DERIVE: "파생 객실 - 부모 객실 유형에서 파생",
    DERIVE_OF_ROOM: "파생된 객실",
    COPY_BY_FOMULAR: "수식으로 복사",
    PASTE: "붙여넣기",
    DATE_RANGE: "날짜 범위",
    CODE_IS_EXISTED: "서비스 코드가 이미 존재합니다",
    HOTEL_CHANGE_SUCCESS: "호텔 변경 성공",
    ROOM_CLASS: "객실 유형",
    UPDATE_FOR: "{date}에 대해 업데이트",
    UPDATE_RATE_BY_RANGE: "일괄 업데이트",
    BOOKER: "예약자 이름",
    SEARCH_BY_BOOKER: "손님 이름",
    CONTACT_US: "문의하기",
    UPDATE_TO_STOP_SELLING_OPENING: "판매 중지/판매 개시 업데이트",
    UPDATE_ROOM_AVAILABILITY_IN_STAGES: "일괄 업데이트",
    UPDATE_SELLING_PRICES_IN_STAGES: "요금 업데이트",
    UPDATE_STOP_SELL: "판매 중지 업데이트",
    UPDATE_SELL_LIMIT_BY_OTA: "판매 한도 업데이트",
    UPDATE_SELL_LIMIT_FOR_NEW_OTA: "새 OTA 판매 한도 업데이트",
    UPDATE_RESTRICTION_STOPSELL: "판매 중지 업데이트",
    UPDATE_STOP_SELL_BY_OTA: "OTA로 판매 중지 업데이트",
    DELETE_SELL_LIMIT_BY_OTA: "OTA 판매 한도 삭제",
    DELETE_STOP_SELL_BY_OTA: "OTA 판매 중지 삭제",
    OTHER_FUNCTION: "기타 기능",
    VIEW_MOBILE_VERSION: "모바일 버전 보기",
    VIEW_DESKTOP_VERSION: "데스크탑 버전 보기",
    FILTER_RESULTS: "결과 필터링",
    STOPSELL_UPDATE_SUCCESS: "판매 중지 업데이트 성공",
    REMOVE_STOPSELL_SUCCESS: "판매 중지 해제 성공",
    HOTEL: "0 호텔 | 1 호텔 | {count} 호텔",
    NIGHT_NUMBER: "객실 밤",
    CONFIRM_STOP_SELL: "판매 중지 업데이트 확인",
    CONFIRM_REMOVE_STOP_SELL: "판매 중지 해제 적용 확인",
    APP: "앱",
    ENTER_THE_NAME_OF_THE_APP_WANT_TO_SEARCH_FOR: "검색하려는 앱 이름을 입력하세요",
    LABEL_NIGHT_BACKGROUND_COLOR: "하위 배경 색상 1",
    LABEL_NIGHT_TEXT_COLOR: "하위 텍스트 색상 1",
    PACKAGE_TEXT_COLOR: "판매 패키지 텍스트 색상",
    PROMOTION_BACKGROUND_COLOR: "보조 배경 색상 2",
    PROMOTION_TEXT_COLOR: "보조 텍스트 색상 2",
    PRICE_TEXT_COLOR: "가격 색상 1",
    RANK_STAR_COLOR: "별 색상",
    TEXT_PRICE_2_COLOR: "가격 색상 2",
    SUB_TEXT_3_COLOR: "추가 텍스트 색상 3",
    SUB_BACKGROUND_3_COLOR: "하위 배경 색상 3",
    RE_SYNC: "예약 재전송",
    CONFIRM_RE_SYNC: "재전송 확인",
    HOTEL_REPORT_BOOKING: "예약 재전송",
    UPDATE_INTERVAL_IS_NOT_MORE_THAN_ONE_YEAR: "업데이트 간격은 1년을 초과할 수 없습니다",
    ACCOUNT_IS_NOT_CONNECTED_TO_GDS: "계정이 ezCms GDS에 연결되지 않았습니다",
    DISCONNECT: "연결 해제",
    CONFIRM_DISCONNECT_OTA: "연결을 해제하시겠습니까?",
    CONFIRM_CONNECT_OTA: "연결을 다시 하시겠습니까?",
    GDS_OTA: "ezCms GDS",
    ROOM_DUPLICATE: "객실 코드가 중복될 수 없습니다",
    ROOM_PLAN_DUPLICATE: "요금 코드가 중복될 수 없습니다",
    YOU_DONT_HAVE_ANY_HOTELS_YET: "호텔이 없습니다.",
    TEXT_GDS_INFOMATION: "GDS는 450,000개 이상의 여행사에서 호텔 객실을 예약하는 전 세계적인 예약 네트워크입니다.",
    ROOM_TYPE_ON_CMS: "ezCrs에서의 객실 유형",
    ROOM_TYPE_ON_SABRE: "판매 채널의 객실 유형",
    ROOM_PLAN_ON_CMS: "ezCrs에서의 요금 계획",
    ROOM_PLAN_ON_SABRE: "판매 채널의 요금 계획",
    CHAIN_CODE: "호텔 체인 코드",
    CHAIN_TYPE: "호텔 체인 유형",
    ITEMS_SHOWING: "표시된 항목",
    TA_NAME: "여행사 이름",
    TA_CODE: "여행사 코드",
    CHAIN_TRAVEL_AGENT_INFOMATION: "여행사 정보",
    ASSIGN_TA_TO_HOTEL: "여행사를 호텔에 할당",
    ALLOW_OVERWRITING_INFOMATION_DOWN_TO_THE_HOTEL: "호텔에 정보 덮어쓰기를 허용",
    FIRST_NAME: "이름",
    LAST_NAME: "성",
    CHAIN_AGENT_LIST: "회사 및 여행사",
    ASSIGN_ROOM_TO_HOTEL: "객실을 호텔에 할당",
    ASSIGN_RATE_PLAN_TO_HOTEL: "객실 요금을 호텔에 할당",
    CHAIN: "체인",
    UNASSIGN: "할당되지 않음",
    ASSIGN: "할당됨",
    CONFIRM_CHANGE_ACTIVE: "여행사 상태 변경 확인",
    ENTERPRISE_CODE: "기업 코드",
    FIRST_NAME_REPRESENT: "대표자 이름",
    LAST_NAME_REPRESENT: "대표자 성",
    ACCOUNT_HOLDER: "계좌 소유자",
    POSITION: "직위",
    HOTEL_LIST: "호텔 목록",
    CHAIN_CONFIG: "체인 설정",
    ASSIGN_SERVICE_TO_HOTEL: "서비스를 호텔에 할당",
    ROOM_TYPE_CODE_HAS_SYNCED_TO_OTA: "호텔 객실 클래스가 동기화되었습니다. 다시 확인해주세요",
    ROOM_CODE_DUPLICATION_ROOM_CODE_IN_CHAIN: "객실 유형 코드가 문자열 객실 유형 코드와 일치합니다. 다시 확인해주세요",
    ROOM_CODE_DUPLICATION: "객실 유형 코드가 이미 존재합니다",
    CHAIN_ROOM_TYPE_IS_OVER_LIMIT: "객실 수가 호텔 수준에서 설정된 총 객실 수를 초과합니다",
    RATE_PLAN_CODE_DUPLICATION: "판매 패키지가 이미 존재합니다. 다시 확인해주세요",
    SERVICE_NOT_EXIST: "서비스가 존재하지 않습니다",
    SERVICE_CODE_DUPLICATION: "서비스 코드가 체인 호텔에 이미 존재합니다. 다시 확인해주세요",
    TRAVEL_AGENT_ALREADY_EXIST: "회사 정보, 여행사가 이미 존재합니다. 다시 확인해주세요",
    HOTEL_NOT_USE_EQUAL_CURRENCY: "호텔이 다른 통화를 사용하도록 설정되었습니다. 다시 확인해주세요",
    AUTO_CANCEL: "예약이 확인되지 않으면 자동 취소 허용",
    ACCOUNT_IS_NOT_CONNECTED_TO_SITEMINDER: "계정이 ezCms SiteMinder에 연결되지 않았습니다",
    ACCOUNT_IS_NOT_CONNECTED_TO_TRAVELOKA: "계정이 ezCms Traveloka에 연결되지 않았습니다",
    ROOM_TYPE_MAP_UNMAP: "현재 연결된 객실 유형은 선택 해제 후 저장 시 연결이 끊어집니다. 이 작업은 연결 상실, 오버부킹, 예약 연결 해제를 초래할 수 있습니다",
    OTA_HOTEL_CODE_ALREADY_EXITS: "입력한 호텔 코드가 이미 연결되었습니다. 다시 확인해주세요!",
    ADD_SERVICE_TO_ROOM_RATE: "판매 계획에 서비스 추가",
    CONFIRM_DELETE_SERVICE_PACKAGE: "이 서비스를 객실 요금에서 제거하시겠습니까?",
    PACKAGE_DEAL: "패키지 거래",
    PACKAGE_ITEM: "패키지 항목",
    PRICE_ALLOCATION: "가격 배분",
    WEEKLY_PRICE: "주간 요금",
    DAILY_PRICE: "일일 요금",
    RD_DAY: "{day}일",
    TOTAL_PACKAGE_VALUE: "총 패키지 가치",
    LIST_EDIT_SUCCESS: "업데이트 성공",
    INFOMATION_OF_BANK_ACCOUNT: "은행 계좌 정보",
    CHILD_HAS_MORE_OTA_THAN_MASTER: "관계를 생성할 수 없습니다",
    ENTIRE_HOTEL: "호텔 수준",
    ACCORDING_TO_EACH_ROOM_CLASS: "객실 유형 수준",
    NUMBER_OF_ROOMS_AVAILABLE: "사용 가능한 객실 수",
    ROOM_OCCUPANCY: "객실 점유율",
    EDIT_DYNAMIC_PRICING: "동적 가격 책정 템플릿 세부 사항",
    ADD_NEW_DYNAMIC_PRICING: "새 동적 가격 책정 모델 추가",
    DYNAMIC_PRICING: "동적 요금",
    CONFIRM_DELETE_DYNAMIC_PRICING: "동적 가격 책정 패턴 삭제 확인",
    DYNAMIC_NAME: "동적 가격 책정 모델 이름",
    DYNAMIC_DESCRIPTION: "동적 가격 책정 패턴 설명",
    CRITERIA: "기준",
    PRICE_CALCULATION_FORMULA: "가격 계산 공식",
    TOTAL_NUMBER_OF_ROOMS_BY_ROOM_CLASS: "객실 유형별 총 판매된 객실 수 (사용 날짜 예약을 포함한 객실 유형의 판매된 객실 수)",
    TOTAL_NUMBER_OF_ROOMS_BY_HOTEL: "호텔별 총 판매된 객실 수 (Day Use 예약을 포함한 호텔의 판매된 객실 수)",
    TOTAL_NUMBER_OF_AVAILABLE_ROOMS_BY_ROOM_CLASS: "객실 유형별 총 사용 가능한 객실 수",
    TOTAL_NUMBER_OF_AVAILABLE_ROOMS_BY_HOTEL: "호텔별 총 사용 가능한 객실 수",
    ROOM_CAPACCITY_FORMULA: "객실 용량 공식",
    FROM_TO_LESS: "From {val} to less than",
    NO_PRIOTITY: "우선순위 없음",
    PRIOTITY: "우선순위",
    UN_SELECT_ALL: "삭제",
    SET_THE_PRICE_CYCLE: "동적 판매",
    EVENT: "이벤트별",
    CALENDAR: "일정 (곧 출시 예정)",
    DYNAMIC_RATE_METHOD: "동적 요금 방식",
    CONFIRM_DEACTIVE_DYNAMIC_RATE: "동적 가격 책정 비활성화 확인",
    RMS_MANAGEMENT: "수익 관리",
    DERIVED_ROOMTYPE: "파생된 객실 유형",
    BASE: "기본 객실 유형",
    UPDATE_FORMULAR: "공식 업데이트",
    FORMULAR: "공식",
    SET_UP_FORMULAR_BY_DATE_RANGE: "날짜 범위별 공식 설정",
    MASTER_RATE: "마스터 요금",
    SET_UP_FORMULAR: "공식 설정",
    CONFIRM_DELETE_FORMULA: "공식 삭제 확인",
    EDIT_PRICE: "가격 수정",
    FOR_EXAMPLE_SERVICE: "예시 서비스: <br> 10월 1일부터 10월 10일까지 예약 (9박) <br> 사용자 지정 설정: <br> <ul> <li> 1박부터 시작: 1 </li> <li> 마지막 날 종료: 마지막 날 </li> <li> 사용 주기: 2 (일)</li> <li> 반복 횟수: 3 (회)</li></ul> 서비스는 10월 1일부터 10월 10일까지 적용됩니다. <br> 사용 주기가 2 (2일/회) 이므로, 서비스는 10월 1일, 3일, 5일, 7일, 9일에 적용됩니다.<br> 그러나 반복 횟수가 3회이므로, 서비스는 10월 1일, 3일, 5일에만 적용됩니다.",
    SCHEDULINGTYPE_1: "첫날에 적용",
    SCHEDULINGTYPE_2: "마지막 날에 적용",
    SCHEDULINGTYPE_3: "X일에 1회 적용, Y일에서 시작",
    SCHEDULINGTYPE_4: "첫날 제외 모든 밤에 적용",
    SCHEDULINGTYPE_5: "마지막 날 제외 모든 밤에 적용",
    SCHEDULINGTYPE_6: "첫날과 마지막 날에는 적용하지 않음",
    SCHEDULINGTYPE_7: "14박에 적용",
    SCHEDULINGTYPE_8: "임의의 X박에 적용",
    SCHEDULINGTYPE_9: "사용자 정의",
    SCHEDULINGTYPE_0: "모든 밤에 적용",
    EXAMPLE: "예시",
    STARTING_FROMM_NIGHT: "시작일",
    ENDS_ON_NIGHT: "종료일",
    USE_CYCLE: "사용 주기",
    NUMBER_OF_REPETITION: "반복 횟수",
    NUMBER_OF_REPETITION_DETAIL: "사용 주기 (X박에 1회 적용)",
    NIGHT_14_DESCRIPTION: "14박 이상의 예약인 경우, 14박 후에도 선택된 주기에 따라 서비스가 적용됩니다.",
    CODE_NOT_EMPTY: "코드는 중복되거나 공백일 수 없습니다",
    BEFORE_THE_LAST_NIGHT: "마지막 날 전",
    LAST_NIGHT: "마지막 밤",
    CONFIRM_UPDATE_PRICE_SERVICE_GREATER_THAN_TOTAL_PACKAGE: "배정된 가격이 총 패키지 가격보다 큽니다. 업데이트를 확인하시겠습니까?",
    EDIT_ATTRIBUTION: "속성 수정",
    MIN_ROOM_RATE: "최소 객실 요금",
    SETUP_FORMULA: "공식 설정",
    SETUP_FORMULA_BY_DATE_RANGE: "날짜 범위별 공식 설정",
    DELETE_FORMULA: "공식 삭제",
    CAN_NOT_CREATE: "상위 객실 판매에 의존하여 객실 판매를 생성할 수 없습니다",
    HAVE_BEEN_CONNECTED_TO_OTA: "객실 클래스/패키지가 OTA에 연결되었습니다",
    CAN_NOT_INACTIVE_OR_DELETE: "업데이트할 수 없습니다",
    ROOM_RATE_IS_CHILDREN: "업데이트 중인 제품은 파생된 제품입니다",
    TO_LESS: "미만",
    COMBO: "패키지",
    TITLE_DESCRIPTION_DYNAMIC_CHANGE: "이벤트별 변경 방식은 호텔이 이벤트와 관련된 인벤토리를 통해 동적 요금/제약 변경을 구성할 수 있도록 허용합니다:",
    CHANGE_TYPE_1: "PMS에서 인벤토리 업데이트",
    CHANGE_TYPE_2: "온라인 채널에서 예약 푸시/풀",
    CHANGE_TYPE_3: "객실 유형 활성화/비활성화",
    CHANGE_TYPE_4: "동적 요금 공식 생성/수정",
    CHANGE_TYPE_5: "객실 요금 변경",
    CHANGE_TYPE_6: "객실 종료/열기",
    SCHEDULE_DYNAMIC_PRICING: "동적 객실 판매 설정",
    HAVE_BEEN_CONNECTED_TO_DYNAMICPRICING: "동적 요금이 설정된 제품은 삭제할 수 없습니다",
    SERVICE_INCLUDES: "서비스 포함",
    CHAIN_INFO: "체인 일반 정보",
    CHAIN_ROOM_TYPE: "객실 유형 - 체인",
    CHAIN_RATE_PLAN: "객실 패키지 - 체인",
    CHAIN_ROOM_TYPE_AMENITY: "객실 편의시설 - 체인",
    CHAIN_SERVICE: "서비스 - 체인",
    CODE_NOT_VALIDATE: "코드가 유효하지 않습니다",
    PAYMENT_CODE: "결제 코드",
    PAYMENT_TYPE: "거래 유형",
    PAYMENT_STATUS: "거래 상태",
    PAYMENT: "결제",
    REFUND: "환불",
    CANCELLATION_REFUND: "취소 환불",
    CANCELLATION_FEE: "취소 수수료",
    WAITING_PAYMENT: "대기 중",
    SUCCESS_PAYMENT: "결제 성공",
    FAILED: "실패",
    CHAIN_NOT_EXIST: "체인 존재하지 않음",
    CHAIN_TRAVEL_AGENT: "체인 회사 및 에이전트 정보",
    HOTEL_TRAVEL_AGENT: "호텔 회사 및 에이전트 정보",
    BE_MANAGEMENT: "ezBe",
    THE_SYSTEM_IS_LOADING: "시스템이 로딩 중입니다. 잠시 기다려 주세요.",
    OTA_HOTEL_NOT_FOUND: "OTA 호텔을 찾을 수 없습니다.",
    ROOM_CLASS_MAPING: "연결된 객실 유형",
    CONFIRM_SAVE: "연결 정보를 변경하셨습니다. 이 작업은 연결 손실, 언맵 및 초과 예약을 초래할 수 있습니다.",
    UNDO: "취소",
    CONFIRM_UNDO: "방금 변경한 내용이 저장되지 않습니다. 취소하시겠습니까?",
    DEFAULT_LANGUAGE: "주 사용 언어",
    RE_SYNC_CONNECT: "재동기화",
    ez_FOLIO: "ezFolio",
    ez_CLOUDHOTEL: "ezCloudHotel",
    ADVANCE_SEARCH: "고급 검색",
    PRICE_OR_OTA_IS_REQUIRED: "판매 가격 또는 판매 채널이 비어 있을 수 없습니다.",
    UPDATE_BY_ROOM_TYPE: "객실 유형별 업데이트",
    UPDATE_BY_SALE_PACKAGE: "판매 패키지별 업데이트",
    UPDATE_BY_SALE_CHANNEL: "OTA 채널별 업데이트",
    BULK_DELETE: "대량 삭제",
    CONFIRM_UPDATE_OVERWRITE: "이 업데이트는 가격과 포함된 인원 수를 모든 선택된 판매 채널에 대해 덮어씁니다. 업데이트를 확인하시겠습니까?",
    ONLY_UPDATE_PRICE: "가격만 덮어쓰기",
    DAILY_MASTER_RATE: "파생된 일일 요금",
    NUMBER_NIGHT: "박수",
    NUMBER_ROOM: "객실",
    ROOM_CAP: "0 객실 | 1 객실 | {count} 객실",
    BOOKING_CAP: "0 예약 | 1 예약 | {count} 예약",
    CHECKIN_STATUS_RESERVED: "예약됨",
    CHECKIN_STATUS_CHECKIN: "체크인",
    CHECKIN_STATUS_CHECKOUT: "체크아웃",
    CHECKIN_STATUS_NO_SHOW: "노쇼",
    CHECKIN_STATUS_ARRIVAL: "도착",
    CHECKIN_STATUS_DUE_OUT: "퇴실 예정",
    CHECKIN_STATUS_CANCELLED: "취소됨",
    NAME_OF_GUEST_STAYING: "숙박 중인 손님",
    PRICE_EXTRA_DAILY: "일일 추가 요금",
    CHANNEL: "0 채널 | 1 채널 | {count} 채널",
    ASSIGN_RATE_TO_CATEGORY: "카테고리에 요금 계획 할당",
    _CATEGORY: {
        CODE: "카테고리 코드",
        NAME: "카테고리 이름",
        DESCRIPTION: "설명"
    },
    ASSIGN_HOTEL_TO_CATEGORY: "호텔에 카테고리 할당",
    CHAIN_REGIS_INFO: "체인 등록 정보",
    CONFIRM_DELETE_RATE_CATEGORY: "요금 카테고리 삭제 확인",
    RATE_CATEGORY_ALREADY_EXIST: "요금 카테고리가 이미 존재합니다.",
    RATE_PLAN_DOES_NOT_EXIST: "요금 계획이 존재하지 않습니다.",
    CANCEL_REASON: "취소 사유",
    RATE_PMS: "PMS 판매 가격",
    ALL_PLAN: "모든 요금 계획",
    ALL_RATE_CATEGORY: "모든 요금 카테고리",
    TO_PAGE: "1부터 {count}까지의 목록",
    ASSIGN_ROOM_TYPE: "객실 할당",
    CONFIG_RATE_OTA: "OTA 요금 설정",
    CONFIG_RATE_PMS: "PMS 요금 설정",
    UPDATE_RATE_PMS: "가격 업데이트",
    VIEW: "보기",
    CONFIRM_DELETE_SALE_PACKAGE_DATE_RANGE_PMS: "선택한 기간의 가격은 다른 객실 유형과 판매 패키지에서 삭제됩니다. <br>가격을 삭제하시겠습니까?",
    WAITING_UPDATE: "데이터가 기록되었으며 처리 중입니다.",
    STATUS_ROOM_TYPE_ON_OTA: "OTA에서의 연결 상태",
    BOOKING_LIST_GROUP: "그룹 예약",
    _GROUP_STATUS: {
        HOLD: "보류",
        TENTATIVE: "임시 예약",
        CONFIRMED: "확인됨",
        CANCELED: "취소됨",
        CHECKED_IN: "체크인 완료",
        CHECKED_OUT: "체크아웃 완료",
        CLOSE: "닫힘",
        NO_SHOW: "노쇼"
    },
    _BOOKING_GROUP: {
        BOOKING_GROUP_NAME: "그룹 예약 이름",
        BOOKING_GROUP_CODE: "그룹 예약 코드",
        GROUP_PROFILE_NAME: "그룹 프로필 이름",
        GROUP_PROFILE_CODE: "그룹 프로필 코드",
        BOOKING_GROUP_START_DATE: "시작 날짜",
        BOOKING_GROUP_END_DATE: "종료 날짜",
        BOOKING_GROUP_CREATE_DATE: "생성 시간",
        STATUS: "그룹 상태"
    },
    ENTER_TEXT: "{text} 입력",
    LIST_PROFILE_GROUP: "그룹 레코드 목록",
    PROFILE_GROUP: "그룹 프로필",
    SEARCH_BY_PROFILE_NAME_AND_CODE: "프로필 이름 또는 프로필 코드, 이메일, 주소로 검색",
    BOOKINGS_GROUP: "그룹 예약 수",
    PROFILE_NUMBER: "{count} 레코드",
    _GROUP: {
        CONFIRM_DELETE: "그룹 기록 삭제 확인",
        DETAIL: "팀 프로필 세부 사항",
        INFO: "프로필 정보",
        INFO_MANAGE: "관리 정보",
        ASSIGN: "위임 할당",
        GROUP_PROFILE_NAME: "프로필 이름",
        GROUP_PROFILE_NAME_OTHER: "기타 이름",
        COMPANY_NAME: "회사 / 에이전트 이름",
        DESCRIPTION: "설명",
        CONTACT_NAME: "대표자 이름",
        PHONE_NUMBER: "전화번호",
        PHONE_NUMBER_OTHER: "기타 전화번호",
        MANAGE_NAME: "매니저의 이름과 성",
        DETAIL_BOOKING: "그룹 예약 세부 사항",
        GROUP_INFO: "그룹 정보",
        LEADER: "리더",
        PMS_CCODE: "PMS 코드",
        CUS_OF_DAYS: "마감일",
        CUT_OF_DATE: "마감 날짜",
        PAYMENT_INFO: "결제 정보",
        TOTAL: "총 금액",
        UPDATE_PROFILE: "크루 프로필 업데이트",
        PAYMENT_METHOD: "결제 방법",
        PAYMENT_METHOD_BOOKING_RETAIL: "개별 결제 방법",
        BOOKING_GROUP_INFO: "그룹 예약 정보",
        LEADER_NOT_PAY: "리더는 결제하지 않음",
        LEADER_PAY_ONE_PART: "파티 결제 리더",
        LEADER_PAYS_ALL: "전체 결제 유니온 필드",
        CHOOSE_PROFILE: "유니온 프로필 선택",
        TITLE: "제목"
    },
    ROOM_OF_LEADER: "리더의 객실",
    NUMBER_OF_BOOKING: "예약 수",
    SUB_BOOKING_CODE: "하위 그룹 코드",
    UPDATE_INFO_BOOKING_GROUP: "그룹 예약 파일 정보 업데이트",
    ALLOW_OVERWRITING_INFOMATION_DOWN: "정보 덮어쓰기 허용",
    FILTER: "필터",
    GROUP_PROFILE: "그룹 프로필",
    BOOKING_GROUP_PROFILE: "예약 그룹",
    ASSIGN_HOTEL: "호텔 할당",
    ASSIGN_ROOM_TO_CATEGORY: "카테고리에 객실 할당",
    UPDATE_ROOM_RATE_PMS: "PMS 요금 구성",
    UPDATE_ROOM_RATE_OTA: "OTA 요금 구성",
    BOOKING_UNMAP: "예약 해제",
    CONFIRM_DELETE_ROOM_CATEGORY: "객실 카테고리 삭제 확인",
    CHAIN_ROOM_CATEGORY_ALREADY_EXIST: "체인 객실 카테고리가 이미 존재합니다.",
    ROOM_CATEGORY_ALREADY_EXIST: "객실 카테고리가 이미 존재합니다.",
    ASSIGN_OTA: "채널 할당",
    NOTE_ASIGN_OTA: "참고: 판매 채널은 선택한 객실 카테고리에 자동으로 할당되며 채널에 가입한 호텔에 동기화됩니다. 저장을 누르면 자동으로 설정됩니다.",
    ACTION_TIME: "업데이트 시간",
    PROCESS_TIME: "처리 시간",
    IGNORE: "무시",
    RESEND: "재업데이트",
    LIST_ACTION_PROCESS: "미완료 작업",
    STATUS_PROCESSING: "진행 중",
    STATUS_FAILED: "실패",
    STATUS_DONE: "완료",
    UPDATE_RATE: "요금 업데이트",
    UPDATE_RATE_SPECIAL: "일일 요금 업데이트",
    UPDATE_EXTRA_RATE: "추가 요금 업데이트",
    UPDATE_EXTRA_SPECIAL_RATE: "일일 추가 요금 업데이트",
    UPDATE_AVAIL: "예약 가능 여부 업데이트",
    UPDATE_RESTRICTION: "제한 사항 업데이트",
    PROCESS_CAP: "0 처리 | 1 처리 | {count} 처리",
    CONFIRM_IGNORE: "오류 작업은 다시 업데이트하지 않습니다. 건너뛰기를 선택하시겠습니까?",
    HOTEL_BOOKING_UNMAP_REPOST: "예약 다시 게시",
    UPDATE_RESTRICTION_MINSTAY: "최소 숙박일 업데이트",
    UPDATE_RESTRICTION_MAXSTAY: "최대 숙박일 업데이트",
    UPDATE_RESTRICTION_MINSTAYARRIVAL: "도착일 최소 숙박일 업데이트",
    UPDATE_RESTRICTION_MAXSTAYARRIVAL: "도착일 최대 숙박일 업데이트",
    UPDATE_RESTRICTION_MINBOOKINGWINDOW: "최소 예약 창 업데이트",
    UPDATE_RESTRICTION_MAXBOOKINGWINDOW: "최대 예약 창 업데이트",
    UPDATE_RESTRICTION_EXACTSTAY: "정확한 숙박일 업데이트",
    UPDATE_RESTRICTION_EXACTSTAYARRIVAL: "정확한 도착일 업데이트",
    UPDATE_RESTRICTION_CLOSEDONARRIVAL: "도착일 체크인 불가 업데이트",
    UPDATE_RESTRICTION_CLOSEDONDEPARTURE: "출발일 체크아웃 불가 업데이트",
    UPDATE_RESTRICTION_CLOSED: "판매 중지 업데이트",
    DELETE_PRICE_SPECIAL: "일일 요금 삭제",
    DELETE_EXTRA_RATE: "추가 요금 삭제",
    DELETE_EXTRA_SPECIAL_RATE: "일일 추가 요금 삭제",
    HOTEL_DASHBOARD_IGNORE_TASK: "무시",
    HOTEL_DASHBOARD_REUPDATE_TASK: "다시 업데이트",
    CHAIN_ROOM_UPDATE_QUANTITY: "객실 수 업데이트",
    ROOM_UPDATE_QUANTITY: "객실 수 업데이트",
    CHAIN_ROOM_CATEGORY: "객실 카테고리 - 체인",
    HOTEL_ROOM_CATEGORY: "객실 카테고리",
    HOTEL_RATE_CATEGORY: "요금 카테고리",
    CHAIN_RATE_CATEGORY: "요금 카테고리 - 체인",
    ERROR_CAUSE: "오류 원인",
    INVENTORY_NOT_SYNC: "빈 객실이 동기화되지 않음",
    UNKNOWN_ERROR: "알 수 없는 오류",
    BY_RATE: "정가에 따른",
    BY_FORMULA: "공식에 따른",
    CONFIG_TYPE: "구성 유형",
    FOMULA_FROM_TO: "월요일부터 일요일까지 가격을 계산하는 공식",
    CONFIRM_DEACTIVE_DYNAMIC_RESTRICTION: "유연한 제한 해제 확인",
    EDIT_DYNAMIC_RESTRICTION: "유연한 제한 템플릿 통찰력",
    ADD_NEW_DYNAMIC_RESTRICTION: "새 유연한 제한 템플릿 추가",
    DYNAMIC_RESTRICTION: "동적 제한",
    CONFIRM_DELETE_DYNAMIC_RESTRICTION: "유연한 제한 템플릿 삭제 확인",
    DYNAMIC_RESTRICTION_NAME: "유연한 제한 템플릿 이름",
    DYNAMIC_RESTRICTION_DESCRIPTION: "유연한 제한 템플릿 설명",
    RESTRICTION_CALCULATION_FORMULA: "구성 정보",
    NO_CHANGE: "변경 없음",
    ADULT_CAP: "0 성인 | 1 성인 | {count} 성인",
    CHILD_CAP: "0 어린이 | 1 어린이 | {count} 어린이",
    BABY_CAP: "0 아기 | 1 아기 | {count} 아기",
    USE_MODEL: "모델로 설정",
    ADD_RANGE: "범위 추가",
    MODEL_DESCRIPTION_RESTRICTION: "가격/가격 공식/용량 범위/제한 사항이 선택된 경우 아래 객실 유형 및 판매 패키지에 복사됩니다.",
    MODEL_DESCRIPTION_PRICE: "가격/가격 공식/용량 범위/제한 사항이 선택된 경우 아래 객실 유형 및 판매 패키지에 복사됩니다.",
    NOTE_ROOM_RATE: "B: 해당 객실 유형의 객실 요금. 객실 요금은 객실 판매 화면에 표시되고 업데이트됩니다. 새 객실 요금을 만들 때 객실 유형의 기본 객실 요금이 사용됩니다.",
    DYNAMIC_SALE: "동적 객실 판매",
    NOTE_MODEL_PRICE: "사용자는 템플릿에서 복사된 객실 유형을 편집할 수 있습니다.",
    ACCOUNT_UPDATE: "계정 업데이트",
    ITEMS_PER_PAGE: "페이지당 항목 수",
    UPDATE_RATE_SPECIAL_FROM_CHAIN: "체인에서 요금 업데이트",
    EQUIVALENT_TO_ROOM_NIGHT: "객실 밤에 해당",
    CREATED_BY_ACCOUNT: "계정 생성",
    IS_LEGACY_ROOM_CLASS: "객실 유형과 요금 계획이 파생되어 삭제할 수 없습니다.",
    ASSIGN_RATE_CATEGORY: "요금 카테고리 할당",
    ASSIGN_ROOM_CATEGORY: "객실 카테고리 할당",
    CUSTOMER_PHONE: "고객 전화번호",
    CUSTOMER_MAIL: "고객 이메일",
    DU_DESCRIPTION_OF_ROOM_TYPE: "객실 유형의 일일 사용 예약 (도착일 = 출발일인 예약)",
    DU_DESCRIPTION_OF_HOTEL: "호텔의 일일 사용 예약 (도착일 = 출발일인 예약)",
    OVERVIEW: "개요",
    INDEX_P: "점유율 (P)",
    INDEX_P_ROOM: "객실 유형별 용량",
    INDEX_P_HOTEL: "호텔별 점유율",
    INDEX_A: "판매된 객실 수 (일일 사용 포함) (A)",
    INDEX_B: "판매 가능한 객실 수 (B)",
    INDEX_DU: "판매된 객실 수 (일일 사용) (DU)",
    INDEX_INV: "예약 가능 객실",
    BY_ROOM: "객실 유형별",
    BY_HOTEL: "호텔별",
    DYNAMIC_NAME_HAS_EXIST: "동적 이름이 이미 존재합니다",
    ROOM_SALE_WITH_ROOM_TYPE: "객실 유형 보기",
    ROOM_SALE_WITH_OTA: "채널별 보기",
    ROOM_FUND: "할당량",
    NODATA_2: "두 글자 이상을 입력해 주세요",
    CHOOSE_MARKET_SEGMENT: "시장 세그먼트 선택",
    MARKET_SEGMENT: "시장 세그먼트",
    TRAVEL_AGENT_SPEC: "특정 여행사",
    SEGMENT_SPEC: "특정 시장 세그먼트",
    SHOW_CARD_PAYMENT_INFO: "카드 정보 보기",
    ENTER_TO_SEARCH_MORE: "검색하려면 입력하세요",
    EMAIL_ACCESSTOKEN: "카드 정보 접근 코드를 받을 이메일",
    TEXT_NOTIFY_EXPIRED_GROUP_OTA: "{채널} 기능이 {날짜}에 만료되었습니다",
    TEXT_NOTIFY_WILL_EXPIRE_GROUP_OTA: "{채널} 기능이 {날짜}에 만료됩니다",
    PLEASE_RENEW: ". 지원이 필요하시면 이메일 <u>hotro@ezcloud.vn</u> 또는 핫라인 <u>1900 9013</u>으로 연락해 주세요.",
    NOTIFY_OFF_MODULE: "객실 유형별 판매 기능이 곧 중단될 예정입니다. 모든 의견은 메일박스 <b>hotro@ezcloud.vn</b>으로 보내주세요",
    NEW_MESSAGE: "새로운 메시지",
    PAXONE: "1인 가격",
    PAXTOW: "2인 가격",
    PAXEXTRA: "추가 인원당 가격",
    MAP_PRODUCT: "상품 할당",
    UPDATE_RESTRICTION_BY_RATE_PLAN: "제한 사항 업데이트",
    CREATE_RESTRICTION: "제한 사항 생성",
    DELETE_ROOM_RATE: "객실 요금 삭제",
    UPDATE_SPECIAL_RATE: "일일 요금 업데이트",
    HERE: "여기",
    ACCESS_TOKEN_EMAIL_IS_NOT_EMPTY: "카드 정보를 받을 이메일을 추가해 주세요",
    ADD_PROGRAM: "프로그램 추가",
    TYPE_APPLY_PROMOTION: "프로모션 시스템",
    PROMOTION_CHARCE_COUPON: "프로모션, 할인 코드",
    PROMOTION_CHARGE: "프로모션 적용",
    COUPON_APPLY: "할인 코드 적용",
    EZ_PROMOTION_NOT_SUPPORTED_PROMOTION_TYPE: "ezPromotion 시스템은 이 유형의 프로모션을 지원하지 않습니다",
    ERROR_EZ_PROMOTION: "ezPromotion 시스템에 연결할 수 없습니다",
    CANCEL_PROMOTION_ERROR: "프로모션 취소 실패",
    CONFIRM_PROMOTION_ERROR: "프로모션 확인 실패",
    RELOAD: "새로 고침",
    WARNING: "경고",
    TXT_WARNING_OVER: "시스템 성능을 보장하기 위해 한 번의 작업으로 50줄 이상 업데이트하지 마세요. 감사합니다!",
    CONFIRM_DELETE_DATA_ENTERED: "방금 주요 상품을 변경했습니다. 방금 입력한 가격 데이터를 삭제하시겠습니까?",
    ROOM_STATUS_1: "예약됨",
    ROOM_STATUS_2: "체크인",
    ROOM_STATUS_3: "체크아웃",
    ROOM_STATUS_4: "노쇼",
    ROOM_STATUS_5: "취소됨",
    BOOKING_HISTORY: "예약 내역",
    BOOKING_STATUS_OTA: "OTA 예약 상태",
    BOOKING_OTA_STATUS_0: "새로운 예약",
    BOOKING_OTA_STATUS_1: "수정된 예약",
    BOOKING_OTA_STATUS_2: "취소된 예약",
    BOOKING_OTA_STATUS_3: "예약 전달",
    COPY_RATE: "요금 계획 복제",
    SALE_PACKAGE_CODE_NEW: "새 요금 계획 코드",
    SELLING_PACKAGE_NEW: "새 요금 계획 이름",
    DUPLICATE: "중복",
    SALE_PACKAGE_CODE_OLD: "기존 요금 계획 코드",
    FAST_UPDATE: "빠른 업데이트",
    AUTO_CANCEL_PAYMENT_FAIL: "결제 실패 예약 자동 취소 허용, 이후",
    EZPAYREF: "참조 코드",
    TOOLTIP_AUTO_CANCEL_PAYMENT_FAIL: "이 기능이 활성화되면 결제 실패 상태에 있는 예약이 설정된 기간 후 자동으로 취소됩니다. 첫 설정에서 기본 시간은 30분입니다. 비워두면 적용 값은 0분입니다.<br>참고: 연결 상태에 따라 취소 시간이 몇 분 정도 지연될 수 있습니다.",
    TOOLTIP_AUTO_CANCEL: "선결제가 필요한 예약에 대해 고객이 현금 또는 은행 이체와 같은 ezCrs에 기록되지 않은 형태로 결제/예치금을 입금한 경우 호텔은 해당 예약을 확인해야 합니다. 이 기능이 활성화되면 ezCrs는 해당 날짜에 확인되지 않은 예약을 자동으로 취소합니다. 예약 자동 취소 날짜는 결제 정책에서 설정되며 각 요금 정책에 따라 적용됩니다.",
    CONFIG_BY: "설정자",
    LIST_FORMULAR: "공식 목록",
    ROOM_TYPE_BASE: "기본 객실 유형",
    SALE_PACKAGE_BASE: "기본 가격 정책",
    SALE_CHANNEL_BASE: "기본 판매 채널",
    ROOM_TYPE_DERIVED: "파생된 객실 유형",
    SALE_PACKAGE_DERIVED: "파생된 요금 계획",
    SALE_CHANNEL_DERIVED: "파생된 판매 채널",
    HOTEL_LOG_derivationType: "레시피 유형",
    HOTEL_LOG_formulaType: "유형",
    HOTEL_LOG_master: "마스터",
    HOTEL_LOG_children: "자식",
    HOTEL_LOG_formula: "공식",
    HOTEL_ROOM_TYPE_SPECIAL: "객실 요금 업데이트",
    UPDATE_ROOM_TYPE: "객실 유형 업데이트",
    TOOLTIP_BASE_ROOM_TYPE: "기본 객실 유형 {value}의 객실 유형과 동일한 요금 계획 및 판매 채널을 공유하는 파생된 유형의 객실 유형 제품만 공식에 따라 파생됩니다.",
    TOOLTIP_BASE_RATE_PLAN: "기본 요금 계획 {value}의 요금 계획과 동일한 객실 유형 및 판매 채널을 공유하는 파생된 요금 계획의 제품만 공식에 따라 파생됩니다.",
    TOOLTIP_BASE_OTA: "기본 판매 채널 {value}의 판매 채널과 동일한 요금 계획 및 객실 유형을 공유하는 파생된 채널의 제품만 공식에 따라 파생됩니다.",
    VALUE_AND_PERSON_IS_REQUIRED: "가격과 게스트 수를 입력해야 합니다",
    PLS_CHOOSE_ONE_SELECT_BOX: "적어도 하나의 '삭제' 상자를 선택하여 업데이트하세요",
    NOTE_DERIVED: "새 파생 공식은 이전 공식을 덮어씁니다. 파생된 제품 또는 기본 제품과 일치하는 경우",
    ROOM_QUANTITY_PARENT_NOT_SAME: "부모와 자식 객실의 객실 수가 같아야 생성할 수 있습니다",
    IS_REDIRECTING: "리디렉션 중",
    MAP: "지도",
    SYNC_FROM_PRICELABS: "Pricelabs에서 동기화",
    HOTEL_EXTRA_SPECIAL_RATE_DELETE: "일일 추가 요금 삭제",
    HOTEL_EXTRA_SPECIAL_RATE_UPDATE: "일일 추가 요금 업데이트",
    SYNC_DATA_TO_OTA: "OTA에 데이터 동기화",
    MODULE_EZ_PAYMENT_NOT_ACTIVE: "모듈 ezPayment가 활성화되지 않았습니다",
    NOT_DELETE_ROOM_TYPE_CODE_HAS_SYNCED_TO_OTA: "OTA와 연결된 객실 유형은 삭제할 수 없습니다",
    ENABLE_SYNC_NOT_UPDATED: "현재 객실 유형은 OTA와 연결되어 있습니다. 객실 유형에서 게스트 수를 변경하려면 아래 단계를 따라 주세요. 변경 사항이 연결에 영향을 미칠 수 있습니다.<br><br>\
    <span class=\"font-weight-bold\">1단계:</span> 동기화 관리에 접근 => ezCms vela+ 선택 => OTA 매핑 탭을 선택하고 변경하려는 객실 유형을 모든 연결된 OTA 채널에서 분리하세요.<br>\
    <span class=\"font-weight-bold\">2단계:</span> 채널 탭을 선택하고 변경하려는 객실 유형을 분리하세요.<br>\
    <span class=\"font-weight-bold\">3단계:</span> 게스트 수를 변경하고 OTA 채널을 다시 연결하세요.<br><br>\
    <span class=\"font-weight-bold\">참고:</span> 연결 오류를 방지하려면 단계를 올바른 순서대로 따르세요. 그렇지 않으면 수익 손실이 발생할 수 있습니다.<br>\
    자세한 사항은 <a href=\"https://help.ezcms.vn/tich-hop-he-thong-ezcms-vela/\" target=\"_blank\"><u>여기</u></a>에서 확인하세요.",
    ENABLE_SYNC_NOT_CREATED: "객실 유형 코드가 이미 호텔 레벨에 존재하므로 OTA와 연결된 상태에서는 변경할 수 없습니다. 객실 유형 코드를 변경하거나 이 객실 유형의 게스트 수를 체인 또는 호텔에서 조정하세요.",
    UNDERSELL_LIMIT_TITLE: "채널별로 객실 판매를 제어할 수 있도록 가용 객실 임계값을 설정하세요. 해당 채널에서 가용 객실 수가 이 임계값에 도달하거나 이를 하회하면 판매 중지 조치가 트리거됩니다.",
    SELL_LIMIT_TITLE: "채널 그룹별로 최대 객실 한도를 설정하여 객실 판매를 제어하고 수익을 최적화하세요.",
    ROOM_FOR_SALE: "판매 가능한 객실",
    NO_CHANNEL_GROUP: "업데이트할 채널 그룹을 선택하세요",
    DATA_BLANK: "입력 데이터는 비워둘 수 없습니다",
    ROOM_QUANTITY_PARENT_NOT_SAME: "부모와 자식 객실 유형의 수가 같아야 생성할 수 있습니다",
    VALUE_MUST_BE_LESS_THAN_24H: "값은 24시간 미만이어야 합니다",
    N_O: "번호",
    MASTER_ROOM_TYPE: "마스터 객실 유형",
    MASTER_RATE_PLAN: "마스터 요금 계획",
    MASTER_CHANNEL: "마스터 채널",
    DERIVED_ROOM_TYPE: "파생된 객실 유형",
    DERIVED_RATE_PLAN: "파생된 요금 계획",
    DERIVED_CHANNEL: "파생된 채널",
    MASTER_PRODUCT: "마스터 제품",
    FORMULAR_LIST: "공식 목록",
    DERIVED_PRODUCT: "파생된 제품",
    PRICE_FORMULA: "가격 공식",
    SELECT_TYPE: "유형 선택",
    SHOW_MORE_FOMULA: "공식 더 보기",
    SELECT_TYPE_RESTRICTION: "제한 유형 선택",
    SETUP_FORMULAR_LIST: "공식 목록 설정",
    APPLY_DATE: "적용 날짜",
    LIST_FROM: "목록 시작",
    TO: "까지",
    IN: "내에서",
    NO_TYPE_SELECTED: "요금 또는 제한 유형을 선택하여 공식을 생성하세요",
    ROOM_TYPE_NOT_MATCH: "객실 유형과 요금 계획 또는 채널이 기본 제품과 파생 제품 간에 일치하지 않아서 공식을 설정할 수 없습니다. 다시 확인하거나 해당 제품을 생성하세요.",
    SALE_PACKAGE_NOT_MATCH: "객실 유형 또는 채널이 기본 제품과 파생 제품 간에 일치하지 않아서 공식을 설정할 수 없습니다. 다시 확인하거나 해당 제품을 생성하세요.",
    SALE_CHANNEL_NOT_MATCH: "요금 계획이나 객실 유형이 기본 제품과 파생 제품 간에 일치하지 않아서 공식을 설정할 수 없습니다. 다시 확인하거나 해당 제품을 생성하세요.",
    CUSTOM_NOT_MATCH: "마스터 제품과 자식 제품 간의 객실 유형, 요금 계획 또는 채널 불일치로 인해 공식을 설정할 수 없습니다.",
    CHANGE: "변경",
    CURRENT_FORMULA: "현재 공식",
    NEW_FORMULA: "생성된 공식",
    MODIFIED_FORMULA: "수정된 공식",
    DELETED_FORMULA: "삭제된 공식",
    DERIVED: "파생된",
    LIST_FORMULAR_UPDATE: "업데이트된 공식",
    BEFORE: "이전",
    AFTER: "이후",
    ROOM_RATE_DERIVATIONS_NOT_FOUND: "객실 요금 파생이 발견되지 않았습니다",
    UPDATE_RESTRICTION_MINBOOKINGWINDOWBYHOUR: "최소 예약 창 시간 단위로 업데이트",
    UPDATE_RESTRICTION_MAXBOOKINGWINDOWBYHOUR: "최대 예약 창 시간 단위로 업데이트",
    NUMBER_OF_DAYS: "일 수",
    NUMBER_OF_HOURS: "시간 수",
    REMOVE_DAYLY_RATE: "일일 요금 제거",
    ALLOW_CHECKIN: "체크인 허용",
    ALLOW_CHECKOUT: "체크아웃 허용",
    QUICK_UPDATE: "유형 업데이트",
    BASE_PRICE_REQUIRED: "주간 요금을 먼저 업데이트하세요",
    CALENDAR_ROOM: "달력 보기",
    WARNING_EMAIL: "이메일",
    SAFE_PRICE_RANGE: {
        PROTECTION_RATE: "보호율",
        PROTECTION_RATE_TOOLTIP: "보호율은 설정된 최소 요금보다 낮거나 최대 요금보다 높은 경우 저장할 수 없는 요금 범위입니다.",
        MINIMUM_RATE: "최소 요금",
        MAXIMUM_RATE: "최대 요금",
        MINIMUM_RATE_INVALID: "최소 요금은 최대 요금보다 높을 수 없습니다.",
        MAXIMUM_RATE_INVALID: "최대 요금은 최소 요금보다 낮을 수 없습니다.",
        PROTECTION_RATE_INPUT_INVALID: "입력 값은 {priceMin}보다 작거나 {priceMax}보다 클 수 없습니다.",
        MINIMUM_RATE_INPUT_INVALID: "입력 값은 {priceMin}보다 작을 수 없습니다.",
        MAXIMUM_RATE_INPUT_INVALID: "입력 값은 {priceMax}보다 클 수 없습니다.",
    },
    PRICE_OUT_OF_BOUND: "입력 요금이 보호율을 초과했습니다.",
    PRICE_UPDATE_OUT_OF_BOUND: "현재 판매 요금이 보호율을 초과했습니다.",
    INCLUDED_TAX: "세금 포함",
    ACTIVATE: "활성화",
    NO_RANK: "순위 없음",
    ONE_STAR: "1성",
    TWO_STAR: "2성",
    THREE_STAR: "3성",
    FOUR_STAR: "4성",
    FIVE_STAR: "5성",
    EXAMPLE_INFO: `<p><i><u><span>예시:</span></u></i></p> 
    <p>호텔이 사용하는 통화: <span>VND</span></p> 
    <p>디럭스룸의 신고 가격: <span>900,000</span></p> 
    <p>환율: <span>0.00005</span></p> 
    <p>가격 차이: <span>0.5</span></p> 
    <p>OTA 채널 동기화 후 디럭스룸의 판매 가격은: <span>(900,000 x 0.5) + 0.5 = 50 $</span></p>`,
    FREE_SALE_ALLOTMENT: "커트오프 날짜까지의 프리세일 배정",
    ACTIVITY_LOG: "로그 0개 | 로그 1개 | 로그 {count}개",
    TIPS: "팁",
    _CONFIGURATION: {
        MENU: "메뉴",
        WIDGET: "위젯",
        THEME: "테마",
        SCRIPT: "스크립트",

        MENU_HEADER: "메뉴 헤더",
        MENU_FOOTER: "메뉴 푸터",

        LOGO: "로고",
        HEADER: "헤더",
        BE_CONTENT: "BE 콘텐츠",
        FOOTER: "푸터",
        FOOTER_BOTTOM: "푸터 하단",
        FOOTER_RIGHT: "푸터 오른쪽",
        WIDGET_FOOTER_RIGHT: "위젯 푸터 오른쪽",
        WIDGET_FOOTER_BOTTOM: "위젯 푸터 하단",

        WIDGET_SOCIAL_MEDIA_ICON: "위젯: 소셜 미디어 아이콘",
        WIDGET_HTML_TEXT: "위젯: HTML 텍스트",
        SCRIPT_WILL_ADD_BODY: "<body>에 스크립트가 추가됩니다",
        SCRIPT_WILL_ADD_HEAD: "<head>에 스크립트가 추가됩니다",
        TEMPLATE: "템플릿",
        BODY: "본문",
        BE_SUPPORT: `<p class="fs-14"><b>방법 1: 미리 만들어진 폼을 이용한 통합</b></p>
        <p>이 기능은 Booking Engine을 웹사이트와 통합할 수 있게 해줍니다. 구체적으로는 Booking Engine의 예약 폼을 웹사이트에 표시할 수 있습니다.</p>
        <img src="/script-BE.png">
        <br>
        <p><b>1단계:</b> 아래 HTML 코드를 복사하여 웹사이트에서 예약 폼을 표시하려는 위치에 붙여넣습니다.</p>
        <div>
            <i>&lt;div class="booking-form"&gt;&lt;/div&gt;</i>
        </div>
        <div class="mt-3">
            <p><b>2단계:</b> 아래 스크립트를 복사하여 웹사이트의 푸터에 붙여넣습니다 (body 태그 종료 전에).</p>
            <p>1. 웹사이트에 jquery가 없는 경우:</p>
            <i> &emsp;&lt;script src="https://apps.oneinventory.com/plugins/ezbe-chain-jquery-5s.js"&gt;&lt;/script&gt; <br>
            &emsp;&lt;script&gt;<br>
            &emsp;&emsp;create_booking_form('XXXXXX', '.booking-form', 'vi', 'VND', 'horizontal', '#ffffff', '#fc5b62');<br>
            &emsp;&lt;/script&gt;<br></i>
        </div>
        <div class="mt-3">
            <p>2. 웹사이트에 jquery가 이미 있는 경우 (스크립트 충돌이 발생할 경우):</p>
            <i>&emsp;&lt;script src="https://apps.oneinventory.com/plugins/ezbe-chain-5s.js"&gt;&lt;/script&gt; <br>
            &emsp;&lt;script&gt; <br>
            &emsp;&emsp;create_booking_form('XXXXXX', '.booking-form', 'vi', 'VND', 'horizontal', '#ffffff', '#fc5b62'); <br>
            &emsp;&lt;/script&gt; <br></i>
        </div>
        <br>
        <p><b>3단계:</b> <b>create_booking_form</b> 함수의 파라미터를 웹사이트에 맞게 조정한 후 저장합니다.</p>
        <p class="mb-1"><b>그 중:</b></p>
        <div class="ml-3">
            <p class="mb-1"><i>XXXXXX</i> : 호텔 코드 (필수).</p>
            <p class="mb-1"><i>.booking-form</i> : 1단계에서 선언한 HTML 요소의 id (#) 또는 class (.) (필수).</p>
            <p class="mb-1"><i>vi</i> : 표시할 언어 코드 (선택 사항). 지원되는 2가지 코드:</p>
                <p class="mb-1 ml-5"><i>vi</i> : 베트남어</p>
                <p class="mb-1 ml-5"><i>en</i> : 영어</p>
            <p class="mb-1"><i>VND</i> : Booking Engine에서 표시할 통화 단위 코드 (국제 통화 코드 표준에 따름, 선택 사항).</p>
            <p class="mb-1"><i>horizontal</i>: 폼 표시 방식 (사용자 정의 가능). 지원되는 2가지 형식:</p>
            <p class="mb-1 ml-5"><i>horizontal</i>: 수평 표시</p>
            <p class="mb-1 ml-5"><i>vertical</i>: 수직 표시</p>  
            <p class="mb-1"><i>#ffffff</i> : 검색 버튼의 글자 색상 코드 (선택 사항).</p>
            <p class="mb-1"><i>#fc5b62</i> : 검색 버튼의 배경 색상 코드 (선택 사항).</p>
        </div>
        <hr>
        <p class="fs-14"><b>방법 2: URL 링크를 이용한 통합</b></p>
        <p>URL을 버튼 또는 링크 텍스트에 할당합니다. 아래의 샘플 URL을 사용하세요:</p>
        <div>
            <i>https://booking.ezcms.vn/hotel/BeDetailHotel?hotel_code=XXXXXX&check_in=2020-11-30&check_out=2020-12-01&num_of_rooms=1&num_of_adults=2&num_of_children=0&promo_code=&rate_code=&room_code=&lang=vi&amp;currency=VND</i>
        </div>
        <br>
        <p class="mb-1"><b>그 중:</b></p>
        <div class="ml-3">
            <p class="mb-1"><i>hotel_code</i>: 호텔 코드 (필수)</p>
            <p class="mb-1"><i>check_in</i>: 체크인 날짜 (YYYY-MM-DD 형식) (선택 사항)</p>
            <p class="mb-1"><i>check_out</i>: 체크아웃 날짜 (YYYY-MM-DD 형식) (선택 사항)</p>
            <p class="mb-1"><i>num_of_rooms</i>: 방 수 (선택 사항)</p>
            <p class="mb-1"><i>num_of_adults</i>: 성인 수 (선택 사항)</p>
            <p class="mb-1"><i>num_of_children</i>: 어린이 수 (선택 사항)</p>
            <p class="mb-1"><i>room_code</i>: 방 유형 코드 (선택 사항)</p>
            <p class="mb-1"><i>rate_code</i>: 요금 정책 코드 (선택 사항)</p>
            <p class="mb-1"><i>promo_code</i>: 프로모션 코드 (선택 사항)</p>
            <p class="mb-1"><i>lang</i> : 표시할 언어 코드 (선택 사항)</p>
            <p class="mb-1"><i>currency</i> : 표시할 통화 단위 코드 (선택 사항)</p>
        </div>
        <hr>
        <p class="fs-14"><b>방법 3: 호텔 웹사이트에 직접 통합</b></p>
        <p>이 기능은 Booking Engine을 호텔 웹사이트에 직접 통합할 수 있게 해줍니다. 즉, 호텔 웹사이트에서 Booking Engine의 객실 목록을 표시할 수 있습니다.</p>
        <p class="mb-3">
            <b>1단계:</b> 아래의 샘플 HTML 코드를 복사하여 예약 폼을 표시하고자 하는 위치에 붙여넣습니다.<br/>
            <i>&lt;div class="booking-form"&gt;&lt;/div&gt;</i>
        </p>
        <p class="mb-3">
            <b>2단계:</b> 아래의 샘플 스크립트를 복사하여 웹사이트의 footer 영역(body 종료 태그 앞)에 붙여넣습니다.<br/>
            <i> &emsp;&lt;script src="https://app.oneinventory.com/booking-engine/plugins/ezbe-embed.js"&gt;&lt;/script&gt; <br>
                &emsp;&lt;script&gt;<br>
                &emsp;&emsp;window.initBookingForm({<br>
                &emsp;&emsp;&emsp; hotel: [{ hotelName: 'Hotel A', hotelCode: 'KSA' }],<br> 
                &emsp;&emsp;&emsp; target: '.booking-form',<br>
                &emsp;&emsp;&emsp; path: '/room-list',<br>
                &emsp;&emsp;&emsp; lang: 'ko',<br>
                &emsp;&emsp;&emsp; background: '#ffffff',<br>
                &emsp;&emsp;&emsp; buttonBackground: '#ff0000',<br>
                &emsp;&emsp;&emsp; buttonTextColor: 'white',<br>
                &emsp;&emsp;&emsp; textColor: '#333333'<br>
                &emsp;&emsp; });<br>
                &emsp;&lt;/script&gt;<br>
            </i>
        </p>
        <p class="mb-0">
            <b>3단계:</b> <b>window.initBookingForm</b> 함수의 설정 값을 호텔 웹사이트에 맞게 조정한 후 저장하세요.
        </p>
        <div class="ml-3">
            <p class="mb-0"><b>설명:</b></p>
            <p class="mb-1">
                - <i>hotel</i> : 호텔 리스트. 한 개 이상의 호텔을 설정할 수 있으며, 각 호텔은 하나의 객체로 정의됩니다. (필수)<br/>
                <span style="padding-left: 12px;"><i>hotelName</i> : 호텔 이름</span><br/>
                <span style="padding-left: 12px;"><i>hotelCode</i> : 호텔 코드</span><br/>
            </p>
            <p class="mb-1">
                - <i>target</i> : 1단계에서 지정한 HTML 태그의 ID (#) 또는 클래스 (.) (필수)
            </p>
            <p class="mb-1">
                - <i>path</i> : 객실 목록이 표시될 페이지 경로. 설정하지 않으면 기본 경로는 <code>https://booking.ezcms.vn</code>입니다 (선택 사항).
            </p>
            <p class="mb-1">
                - <i>lang</i> : 예약 폼 및 객실 리스트에 표시될 언어. 설정하지 않으면 기본값은 베트남어입니다. (선택 사항)<br/>
                <span style="padding-left: 12px;"><b>지원되는 7개 언어:</b></span><br/>
                <span style="padding-left: 12px;"><i>vi</i> : 베트남어</span><br/>
                <span style="padding-left: 12px;"><i>en</i> : 영어</span><br/>
                <span style="padding-left: 12px;"><i>ja</i> : 일본어</span><br/>
                <span style="padding-left: 12px;"><i>ko</i> : 한국어</span><br/>
                <span style="padding-left: 12px;"><i>lo</i> : 라오어</span><br/>
                <span style="padding-left: 12px;"><i>km</i> : 크메르어</span><br/>
                <span style="padding-left: 12px;"><i>zh</i> : 중국어</span><br/>
                <span style="padding-left: 12px;"><b>참고:</b> Booking Engine에서 선택한 언어가 설정되어 있지 않으면 기본 언어는 영어로 표시됩니다.</span>
            </p>   
            <p class="mb-1">
                - <i>background</i> : 폼의 배경 색상. 기본값: #eee (선택 사항)
            </p>
            <p class="mb-1">
                - <i>buttonTextColor</i>: “객실 검색” 버튼의 글자 색상. 기본값: #fff (선택 사항)
            </p>
            <p class="mb-1">
                - <i>buttonBackground</i>: “객실 검색” 버튼의 배경 색상. 기본값: 빨간색 (선택 사항)
            </p>
            <p class="mb-1">
                - <i>textColor</i>: 폼 내 글자 색상. 브라우저 기본값이 적용됩니다. (선택 사항)
            </p>  
        </div>
        <p class="mt-3 mb-0">
            <b>4단계:</b> 3단계에서 설정한 path 경로에 위치한 호텔의 객실 목록 페이지에서
        </p>
        <p class="mb-0">
            아래 HTML 코드를 복사하여 객실 리스트를 표시하고자 하는 위치에 붙여넣습니다.<br/>
            <i>&lt;div id="room-list"&gt;&lt;/div&gt;</i>
        </p>
        <p class="mb-3">
            아래 스크립트를 복사하여 웹사이트의 footer 영역에 붙여넣습니다 (body 태그 닫기 전).<br/>
            <i> &emsp;&lt;script src="https://app.oneinventory.com/booking-engine/plugins/ezbe-embed.js"&gt;&lt;/script&gt; <br>
                &emsp;&lt;script&gt;<br>
                &emsp;&emsp;window.initBookingEngine({<br>
                &emsp;&emsp;&emsp; target: '#room-list',<br>
                &emsp;&emsp;&emsp; scrollToTop: true,<br>
                &emsp;&emsp;&emsp; marginTop: 0<br>
                &emsp;&emsp;});<br>
                &emsp;&lt;/script&gt;<br>
            </i>
        </p>
        <p class="mb-0">
            <b>5단계:</b> 저장하기 전에 <b>window.initBookingEngine</b> 함수의 설정 값을 조정하세요.
        </p>
        <div class="ml-3">
            <p class="mb-0"><b>설명:</b></p>
            <p class="mb-1">
                - <i>target</i> : 4단계에서 정의한 HTML 태그의 ID (#) 또는 클래스 (.) (필수)
            </p>
            <p class="mb-1">
                - <i>scrollToTop</i> : 스크롤이 500px 이상 내려갔을 때 상단 이동 아이콘을 표시. 클릭 시 페이지 맨 위로 이동. 기본값은 false (선택 사항)
            </p>
            <p class="mb-1">
                - <i>marginTop</i> : 위쪽에 여백을 만듭니다. 목적은 고정된 상단 요소(예: 고정 헤더)에 의해 콘텐츠가 가려지지 않도록 하는 것입니다(선택 사항).
            </p>
        </div>
        <p style="margin-top: 10px;"><b>데모 페이지 보기 </b><a href="https://app.oneinventory.com/booking-engine" target="_blank">여기 클릭</a></p>`,
    },
    CONFIRM_TRANET_CONNECT: `{roomConfirm} 방이 최대 수용 인원 18명을 초과했습니다. 지도를 클릭하면 <span class="font-weight-bold">매핑 실패</span> 오류가 발생할 수 있습니다. 다시 한 번 확인해주세요.`,
    _PROMOTION: {
        MEALS: {
            BREAKFAST: "아침식사",
            LUNCH: "점심식사",
            DINNER: "저녁식사",
        },
        PROMOTION_TYPE_LIST: {
            EVERY_NIGHT: "매일 밤",
            TOTAL_BOOKING: "총 예약 금액",
            ORDER_BEFORE: "체크인 x일 전까지 주문",
            ORDER_WITHIN: "체크인 x일 이내 주문",
            FREE_QUANTITY: "x개 주문 시 y개 무료",
            FREE_ON_TOTAL_VALUE: "x개 주문 시 총 금액 기준 y개 무료",
        },
        DISCOUNT_LIST: {
            DISCOUNT: "할인",
            SURCHARGE: "추가 요금",
        },
        TARGET_APPLY_LIST: {
            BY_AGENT_LEVEL: "에이전트 등급별",
            BY_AGENT: "에이전트별",
        },
        LEVEL_TARGET_APPLY: {
            LEVEL_1: "레벨 1",
            LEVEL_2: "레벨 2",
            LEVEL_3: "레벨 3",
            LEVEL_4: "레벨 4",
            LEVEL_5: "레벨 5",
        }
    },
    UTM_CODE: "UTM 코드",
    ZOOM: "줌",
    UPDATE_RESTRICTION_SALEINVENTORY: "판매용 객실 업데이트",
    UPDATE_RESTRICTION_SELLLIMIT: "판매 한도 업데이트",
    ROOM_TYPE_ON_SABRE_DUPLICATE: "판매 채널의 객실 유형은 중복될 수 없습니다",
    ROOM_PLAN_ON_SABRE_DUPLICATE: "판매 채널의 요금제는 중복될 수 없습니다",
    UPDATE_FAILED: "업데이트 실패",
    DELETE_FAILED: "삭제 실패",
    CREATE_FAILED: "생성 실패",
    UPLOAD_FAILED: "업로드 실패",
    USER_NOT_RIGHT: "권한이 없습니다",
    USER_NOT_EXIST: "계정이 존재하지 않습니다",
    EMAI_IS_EXIST: "이메일이 이미 존재합니다",
    ACTIVE_SUCCESS: "성공적으로 활성화되었습니다",
    DEACTIVE_SUCCESS: "성공적으로 연결 해제되었습니다",
    TODAY: "오늘",
    YESTERDAY: "어제",
    TOMORROW: "내일",
    LOGIN_FAILED: "로그인 실패",
    ONEPAY_INLAND: "OnePay 국내",
    ONEPAY_OVERSEA: "OnePay 해외",
    VN_PAY: "VN Pay",
    SUN: "일",
    MON: "월",
    TUE: "화",
    WED: "수",
    THU: "목",
    FRI: "금",
    SAT: "토",
    UNDER_MAX_GUEST: "투숙객 수가 요금 정책에 허용된 최대 인원을 초과합니다",
    SAVE_RESULTS_WHEN_MAKING_CHANGES: "변경 후 결과 저장",
    $vuetify: {
        badge: '배지',
        close: '닫기',
        dataIterator: {
            noResultsText: '일치하는 항목이 없습니다.',
            loadingText: '불러오는 중...'
        },
        dataTable: {
            itemsPerPageText: '페이지 당 행 수:',
            ariaLabel: {
                sortDescending: '내림차순 정렬.',
                sortAscending: '오름차순 정렬.',
                sortNone: '정렬하지 않음.',
                activateNone: '정렬을 취소하려면 활성화하세요.',
                activateDescending: '내림차순 정렬을 위해 활성화하세요.',
                activateAscending: '오름차순 정렬을 위해 활성화하세요.'
            },
            sortBy: 'Sort by'
        },
        dataFooter: {
            itemsPerPageText: '페이지 당 항목 수:',
            itemsPerPageAll: '전체',
            nextPage: '다음 페이지',
            prevPage: '이전 페이지',
            firstPage: '첫 페이지',
            lastPage: '마지막 페이지',
            pageText: '{2} 중 {0}-{1}'
        },
        datePicker: {
            itemsSelected: '{0} 선택됨',
            nextMonthAriaLabel: '다음 달',
            nextYearAriaLabel: '내년',
            prevMonthAriaLabel: '지난달',
            prevYearAriaLabel: '전년도'
        },
        noDataText: '데이터가 없습니다.',
        carousel: {
            prev: '이전 화면',
            next: '다음 화면',
            ariaLabel: {
                delimiter: 'Carousel slide {0} of {1}'
            }
        },
        calendar: {
            moreEvents: '{0} 더보기'
        },
        input: {
            clear: 'Clear {0}',
            prependAction: '{0} prepended action',
            appendAction: '{0} appended action'
        },
        fileInput: {
            counter: '{0} files',
            counterSize: '{0} files ({1} in total)'
        },
        timePicker: {
            am: '오전',
            pm: '오후'
        },
        pagination: {
            ariaLabel: {
                wrapper: 'Pagination Navigation',
                next: '다음 페이지',
                previous: '이전 페이지',
                page: '고토 페이지 {0}',
                currentPage: '현재 페이지, 페이지 {0}'
            }
        },
        rating: {
            ariaLabel: {
                icon: 'Rating {0} of {1}'
            }
        },
        loading: 'Loading...'
    },
    DAYS_OF_WEEK: {
        SUN: "일",
        MON: "월",
        TUE: "화",
        WED: "수",
        THU: "목",
        FRI: "금",
        SAT: "토",
    },
    URL_INVALID: "URL이 유효하지 않습니다",
    SELECT_ROOM_TYPE: "객실 유형 선택",
    OTA_CONNECTION_ERROR: "OTA 연결 오류",
    ROOM_RATE_TYPE: "객실 유형 {room} 요금제 {rate}",
    NOT_MATCH_GUEST_COUNT: "ezCrs와 Traveloka 간 투숙 인원 불일치",
    STAFF_MANAGEMENT: "직원 관리",
    FUNCTION_MANAGEMENT: "기능 관리",
    SETUP_RATE_TYPE: "채널에서 CM으로 전송된 요금 유형 설정",
    INCLUDE_COMMISSION: "커미션 포함",
    EXCLUDE_COMMISSION: "커미션 제외",
    UNDEFINED_COMMISSION: "정의되지 않음",
    EXTRA_DATA_TO_OTA: "채널에서 CM으로 전송된 요금 유형을 설정합니다",
    ROOM_TYPE_SYNCED: "이 객실 유형은 OTA와 매핑되어 있습니다. 다시 한 번 확인해 주세요.",
    MANDATORY_LANGUAGE_REQUIRED: "베트남어와 영어는 필수입니다.",
    TOOLTIP_TOGGLE_LANGUAGE: "표시 언어를 변경할 때는 객실 유형 이름, 정책 이름 등 다국어 필드도 함께 업데이트해야 합니다.",
    TOOLTIP_INCLUDE_COMMISSION: `
        <span class="font-weight-bold fs-13">-설정: 커미션 제외</span> – 채널이 결제를 수금하고 시스템에 충분한 데이터가 있는 경우, ezCrs는 예약 객실 요금을 재계산합니다.<br/>
        <span class="font-weight-bold fs-13">-설정: 커미션 포함</span> – ezCrs는 채널에서 전달된 객실 요금을 그대로 유지합니다.<br/>
        <span class="font-weight-bold fs-13">-설정: 미정</span> – 채널에서 전달된 요금에 커미션 포함 여부를 시스템이 판단할 수 없을 때 사용합니다.
        이 경우 <span class="font-weight-bold fs-13">커미션 포함</span> 및 <span class="font-weight-bold fs-13">커미션 제외</span> 항목은 모두 <span class="font-weight-bold fs-13">미정</span>으로 표시됩니다.`,
    TOOLTIP_INCLUDE_COMMISSION_AGODA: `
        <span class="font-weight-bold fs-13">-설정: 커미션 포함</span> – 시스템에 충분한 데이터가 있는 경우, ezCrs는 예약 객실 요금을 재계산합니다.<br/>
        <span class="font-weight-bold fs-13">-설정: 커미션 제외</span> – ezCrs는 채널에서 전달된 객실 요금을 그대로 유지합니다.<br/>
        <span class="font-weight-bold fs-13">-설정: 미정</span> – 채널에서 전달된 요금에 커미션 포함 여부를 시스템이 판단할 수 없을 때 사용합니다. 이 경우
        <span class="font-weight-bold fs-13">커미션 포함</span> 및 <span class="font-weight-bold fs-13">커미션 제외</span> 항목은 모두 <span class="font-weight-bold fs-13">미정</span>으로 표시됩니다.`,
    INPUT_INVALID: "최대 수량을 초과했습니다",
    GOOGLE_NOTE: "<strong>주의:</strong> Google의 최신 규정에 따라 Google Hotel을 사용하는 호텔은 <strong>세금 및 수수료</strong> 데이터를 업데이트해야 합니다. 시스템의 유효성을 보장하고 오류를 방지하기 위해 <strong>0보다 큰 값의 세금 또는 수수료가 최소 1개 이상</strong> 포함되어야 합니다.",
    INVOICE_REQUEST: "세금계산서 요청",
    COMPANY_NAME_OR_BOOKER: "회사명/예약자명",
    HIDE_INFORMATION: "(정보 숨기기)",
    SHOW_INFORMATION: "(정보 보기)",
    MODULE_EZ_PROMOTION_NOT_ACTIVE: "프로모션 모듈이 활성화되어 있지 않습니다",
    INCLUDE_COMMISSION_RATE: "수수료 포함",
    EXCLUDE_COMMISSION_RATE: "수수료 미포함",
    COMMISSION_RATE_NOTE: "참고: 수수료 포함 및 제외 데이터는 참고용일 뿐입니다",
    SETUP_RATE_TYPE_NOTE: "안내 사항:“채널에서 CM으로 전송되는 요금 설정” 구성 변경은 해당 채널에 최소 1개(01)의 객실 유형이 정상적으로 연결되어 있는 경우에만 가능합니다.",
};